import React from 'react';
import {
  Icon,
  IconButton,
  LinearGradient,
  ScreenContainer,
  SimpleStyleFlatList,
  SimpleStyleScrollView,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { BlurView } from 'expo-blur';
import { ActivityIndicator, Modal, Text, View } from 'react-native';
import { Fetch } from 'react-request';
import * as GlobalStyles from '../GlobalStyles.js';
import * as DefaultApi from '../apis/DefaultApi.js';
import ScenarioBlock from '../components/ScenarioBlock';
import ScreenSizeWarningBlock from '../components/ScreenSizeWarningBlock';
import SideMenuBlock from '../components/SideMenuBlock';
import * as GlobalVariables from '../config/GlobalVariableContext';
import * as BarChart from '../custom-files/BarChart';
import calculatePercentIncome from '../global-functions/calculatePercentIncome';
import cashOnHand from '../global-functions/cashOnHand';
import checkScreenMode from '../global-functions/checkScreenMode';
import findIndextAllCategories from '../global-functions/findIndextAllCategories';
import formatNumber from '../global-functions/formatNumber';
import formatPercentage from '../global-functions/formatPercentage';
import generateDates from '../global-functions/generateDates';
import getCurrentYear from '../global-functions/getCurrentYear';
import getInitValue from '../global-functions/getInitValue';
import newFormatDate from '../global-functions/newFormatDate';
import prefillNumberInputs from '../global-functions/prefillNumberInputs';
import sortCategories from '../global-functions/sortCategories';
import sumArrays from '../global-functions/sumArrays';
import timestampToISO from '../global-functions/timestampToISO';
import toFixed2 from '../global-functions/toFixed2';
import palettes from '../themes/palettes';
import * as Utils from '../utils';
import Breakpoints from '../utils/Breakpoints';
import * as DateUtils from '../utils/DateUtils';
import * as StyleSheet from '../utils/StyleSheet';
import useWindowDimensions from '../utils/useWindowDimensions';

const OverviewScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [allCategoriesFinance, setAllCategoriesFinance] = React.useState([]);
  const [allCategoriesOperating, setAllCategoriesOperating] = React.useState(
    []
  );
  const [allCategoriesOther, setAllCategoriesOther] = React.useState([]);
  const [allCategoriesPayment, setAllCategoriesPayment] = React.useState('');
  const [buttonLabel, setButtonLabel] = React.useState('');
  const [cashOnHands, setCashOnHands] = React.useState({
    ending: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    beginning: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  });
  const [financeData, setFinanceData] = React.useState('');
  const [incomeCategories, setIncomeCategories] = React.useState('');
  const [incomeData, setIncomeData] = React.useState('');
  const [isFetching, setIsFetching] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [monthlyCashOnHand, setMonthlyCashOnHand] = React.useState('');
  const [newCategory, setNewCategory] = React.useState('');
  const [numberInputsFinance, setNumberInputsFinance] = React.useState([]);
  const [numberInputsIncome, setNumberInputsIncome] = React.useState('');
  const [numberInputsOperating, setNumberInputsOperating] = React.useState([]);
  const [numberInputsOther, setNumberInputsOther] = React.useState([]);
  const [numberInputsPaymentForCost, setNumberInputsPaymentForCost] =
    React.useState([]);
  const [operatingData, setOperatingData] = React.useState('');
  const [otherData, setOtherData] = React.useState('');
  const [paymentData, setPaymentData] = React.useState('');
  const [pickerValue, setPickerValue] = React.useState('');
  const [reRender, setReRender] = React.useState(false);
  const [scenarioTitle, setScenarioTitle] = React.useState('');
  const [startingCashOn, setStartingCashOn] = React.useState('');
  const [startingDate, setStartingDate] = React.useState(new Date());
  const [toggleAddCategoryFinance, setToggleAddCategoryFinance] =
    React.useState(false);
  const [toggleAddCategoryOperating, setToggleAddCategoryOperating] =
    React.useState(false);
  const [toggleAddCategoryOther, setToggleAddCategoryOther] =
    React.useState(false);
  const [toggleCreateNew, setToggleCreateNew] = React.useState(false);
  const [toggleNewCategoryFinance, setToggleNewCategoryFinance] =
    React.useState(false);
  const [toggleNewCategoryOperating, setToggleNewCategoryOperating] =
    React.useState(false);
  const [toggleNewCategoryOther, setToggleNewCategoryOther] =
    React.useState(false);
  const [totalCashAvailable, setTotalCashAvailable] = React.useState('');
  const [totalCashPaidOut, setTotalCashPaidOut] = React.useState([]);
  const [totalFinancePerCategory, setTotalFinancePerCategory] = React.useState(
    []
  );
  const [totalFinancePerMonth, setTotalFinancePerMonth] = React.useState([]);
  const [totalIncomePerCategory, setTotalIncomePerCategory] =
    React.useState('');
  const [totalIncomePerMonth, setTotalIncomePerMonth] = React.useState('');
  const [totalOperatingPerCategory, setTotalOperatingPerCategory] =
    React.useState([]);
  const [totalOperatingPerMonth, setTotalOperatingPerMonth] = React.useState(
    []
  );
  const [totalOtherPerCategory, setTotalOtherPerCategory] = React.useState([]);
  const [totalPaymentForCostPerCetagory, setTotalPaymentForCostPerCetagory] =
    React.useState([]);
  const [totalPaymentForCostPerMonth, setTotalPaymentForCostPerMonth] =
    React.useState([]);
  const [visibleWhatIf, setVisibleWhatIf] = React.useState(false);
  const calculateBenchmark = arr => {
    const total = arr.reduce((acc, num) => acc + num, 0);

    const percentageArray = arr.map(num => (num / total) * 100);

    return percentageArray;
  };

  const findIndexExpense = (arr, titleObj) => {
    const titleToCompare = titleObj._expense_heads
      ? titleObj._expense_heads.title
      : titleObj.title;

    return arr.findIndex(item => {
      const itemTitle = item._expense_heads
        ? item._expense_heads.title
        : item.title;
      return itemTitle === titleToCompare;
    });
  };

  const prefillNumberExpense = (data, categories, startingDate) => {
    if (!Array.isArray(categories)) {
      console.error('Categories is not an array:', categories);
      return [];
    }

    const startDate = new Date(startingDate);

    if (isNaN(startDate.getTime())) {
      return [];
    }

    const getMonthIndex = (recordMonth, startDate) => {
      const recordDate = new Date(recordMonth);

      if (isNaN(recordDate.getTime())) {
        return -1;
      }

      const monthsDiff =
        (recordDate.getFullYear() - startDate.getFullYear()) * 12 +
        (recordDate.getMonth() - startDate.getMonth());
      return monthsDiff >= 0 ? monthsDiff : -1;
    };

    const defaultCategories = categories.filter(cat => cat.default_value);
    const customCategories = categories.filter(cat => cat.custom_value);

    const defaultNumberInputs = defaultCategories.map(category => {
      const id = category.id;
      const monthArray = Array(12).fill(0);

      const dataItems = data.filter(item => item.user_expense_heads_id === id);

      dataItems.forEach(item => {
        item.data.forEach(record => {
          const monthIndex = getMonthIndex(
            new Date(record.month).toISOString(),
            startDate
          );
          if (monthIndex >= 0 && monthIndex < 12) {
            monthArray[monthIndex] = record.amount || 0;
          }
        });
      });

      return monthArray;
    });

    const customNumberInputs = customCategories.map(category => {
      const id = category.id;
      const monthArray = Array(12).fill(0);

      const dataItems = data.filter(
        item => item.custom_expense_heads_id === id
      );

      dataItems.forEach(item => {
        item.data.forEach(record => {
          const monthIndex = getMonthIndex(
            new Date(record.month).toISOString(),
            startDate
          );
          if (monthIndex >= 0 && monthIndex < 12) {
            monthArray[monthIndex] = record.amount || 0;
          }
        });
      });

      return monthArray;
    });

    return [...defaultNumberInputs, ...customNumberInputs];
  };

  const pullStartingBalance = (data, startingDate) => {
    const result = [];

    let currentDate = new Date(startingDate);
    currentDate.setUTCDate(1);

    for (let i = 0; i < 12; i++) {
      const matchingRecord = data.find(record => {
        const recordDate = new Date(record.month);
        return (
          recordDate.getUTCFullYear() === currentDate.getUTCFullYear() &&
          recordDate.getUTCMonth() === currentDate.getUTCMonth()
        );
      });

      if (matchingRecord) {
        result.push(matchingRecord.amount);
      } else {
        result.push(0);
      }

      currentDate.setUTCMonth(currentDate.getUTCMonth() + 1);
    }

    return result;
  };

  const sortCategoriesExpense = items => {
    const defaultItems = items
      .filter(item => item.default_value === true)
      .sort((a, b) => a.expense_heads_id - b.expense_heads_id);

    const titleCount = {};

    defaultItems.forEach(item => {
      const title = item._expense_heads.title;

      if (titleCount[title]) {
        titleCount[title]++;
        item._expense_heads.title = `${title} ${titleCount[title]}`;
      } else {
        titleCount[title] = 1;
      }
    });

    const customItems = items.filter(item => item.custom_value === true);

    const otherItems = items.filter(
      item => !item.default_value && !item.custom_value
    );

    return [...defaultItems, ...customItems, ...otherItems];
  };

  const totalCashAvailableOverview = (startingCashOnHand, matrices) => {
    const length = matrices[0].length;
    let columnSums = Array(length).fill(0);

    for (let i = 0; i < length; i++) {
      for (let j = 0; j < matrices.length; j++) {
        columnSums[i] += matrices[j][i];
      }
    }

    let result = [];

    result[0] = startingCashOnHand + columnSums[0];

    for (let i = 1; i < length; i++) {
      result[i] = result[i - 1] + columnSums[i];
    }

    return result;
  };

  const totalCashPaid = (array1, array2, array3) => {
    const length = array1.length;
    let result = Array(length).fill(0);

    for (let i = 0; i < length; i++) {
      result[i] = array1[i] + array2[i] + array3[i];
    }

    return result;
  };

  const totalForCategory = arrays => {
    let result = [];

    for (let i = 0; i < arrays.length; i++) {
      let sum = 0;
      for (let j = 0; j < arrays[i].length; j++) {
        sum += arrays[i][j];
      }
      result.push(sum);
    }

    return result;
  };

  const totalForMonth = arrays => {
    const length = arrays[0].length;
    let result = Array(length).fill(0);

    for (let i = 0; i < length; i++) {
      for (let j = 0; j < arrays.length; j++) {
        result[i] += arrays[j][i];
      }
    }

    let totalSum = result.reduce((acc, val) => acc + val, 0);

    result.push(totalSum);

    return result;
  };

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand.Background,
          },
        },
        dimensions.width
      )}
    >
      {/* Container */}
      <>
        {!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <View
            style={StyleSheet.applyWidth(
              {
                flex: { minWidth: Breakpoints.Laptop, value: 1 },
                flexDirection: { minWidth: Breakpoints.Laptop, value: 'row' },
                maxHeight: {
                  minWidth: Breakpoints.Laptop,
                  value: dimensions.height,
                },
              },
              dimensions.width
            )}
          >
            <SideMenuBlock
              screen={'overview'}
              setToggleWhatIf={toggleWhatIf => setVisibleWhatIf(toggleWhatIf)}
              toggleWhatIf={visibleWhatIf}
            />
            {/* Overview Screen */}
            <View
              style={StyleSheet.applyWidth(
                {
                  backgroundColor: {
                    minWidth: Breakpoints.Laptop,
                    value: checkScreenMode(Variables)
                      ? undefined
                      : palettes.Brand.White,
                  },
                  flex: { minWidth: Breakpoints.Laptop, value: 1 },
                },
                dimensions.width
              )}
            >
              {/* Header */}
              <View>
                <LinearGradient
                  endY={100}
                  startX={0}
                  startY={0}
                  {...GlobalStyles.LinearGradientStyles(theme)[
                    'Header Linear Gradient'
                  ].props}
                  color1={palettes.Brand['App Blue Dark']}
                  color2={palettes.App['App Blue Light']}
                  endX={0}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.LinearGradientStyles(theme)[
                        'Header Linear Gradient'
                      ].style,
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                      }
                    ),
                    dimensions.width
                  )}
                >
                  {/* Left */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        paddingLeft: {
                          minWidth: Breakpoints.Laptop,
                          value: 24,
                        },
                      },
                      dimensions.width
                    )}
                  />
                  {/* Middle */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 3 },
                      },
                      dimensions.width
                    )}
                  >
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Header'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Header'].style,
                          {
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 22,
                            },
                            paddingBottom: {
                              minWidth: Breakpoints.Laptop,
                              value: 10,
                            },
                            paddingTop: {
                              minWidth: Breakpoints.Laptop,
                              value: 10,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Income and Expense Overview'}
                    </Text>
                  </View>
                  {/* Right */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'flex-end',
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        paddingRight: {
                          minWidth: Breakpoints.Laptop,
                          value: 24,
                        },
                      },
                      dimensions.width
                    )}
                  >
                    <IconButton
                      onPress={() => {
                        try {
                          navigation.navigate('BestPracticesScreen');
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      color={palettes.Brand.White}
                      icon={'Entypo/help-with-circle'}
                      size={24}
                    />
                  </View>
                </LinearGradient>
              </View>
              {/* Loading View */}
              <>
                {!(isLoading || isFetching) ? null : (
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        alignSelf: {
                          minWidth: Breakpoints.Desktop,
                          value: 'flex-end',
                        },
                        backgroundColor: {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.App['Black %50'],
                        },
                        flex: { minWidth: Breakpoints.Laptop, value: 1 },
                        gap: { minWidth: Breakpoints.Laptop, value: 20 },
                        height: {
                          minWidth: Breakpoints.Laptop,
                          value: dimensions.height,
                        },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        position: {
                          minWidth: Breakpoints.Laptop,
                          value: 'absolute',
                        },
                        right: [
                          { minWidth: Breakpoints.Desktop, value: 0 },
                          { minWidth: Breakpoints.Laptop, value: 0 },
                        ],
                        width: [
                          {
                            minWidth: Breakpoints.Desktop,
                            value:
                              dimensions.width - dimensions.width * (15 / 100),
                          },
                          {
                            minWidth: Breakpoints.Laptop,
                            value:
                              dimensions.width - dimensions.width * (20 / 100),
                          },
                        ],
                      },
                      dimensions.width
                    )}
                  >
                    <ActivityIndicator
                      animating={true}
                      hidesWhenStopped={true}
                      {...GlobalStyles.ActivityIndicatorStyles(theme)[
                        'Activity Indicator'
                      ].props}
                      size={'large'}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.ActivityIndicatorStyles(theme)[
                          'Activity Indicator'
                        ].style,
                        dimensions.width
                      )}
                    />
                    {/* Message */}
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Header'].props}
                      style={StyleSheet.applyWidth(
                        GlobalStyles.TextStyles(theme)['Header'].style,
                        dimensions.width
                      )}
                    >
                      {'Loading, please wait...'}
                    </Text>
                  </View>
                )}
              </>
              <DefaultApi.FetchGetExpenseHeadsGET
                handlers={{
                  onData: fetchData => {
                    const handler = async () => {
                      try {
                        /* hidden 'Set Variable' action */
                        const incomeHeads = (
                          await DefaultApi.getIncomeHeadsGET(Constants)
                        )?.json;

                        const value7SQ4WREg = sortCategories(
                          (incomeHeads?.income_heads).concat(
                            incomeHeads?.custom_income_heads
                          )
                        );
                        const incCatRes = value7SQ4WREg;
                        setIncomeCategories(value7SQ4WREg);
                        const dataRes = (
                          await DefaultApi.getIncomeGET(Constants, {
                            starting_date: newFormatDate(
                              Constants['STARTING_DATE'],
                              'get'
                            ),
                          })
                        )?.json;

                        const valueSFIlVH9i = [].concat(
                          (dataRes?.default).concat(dataRes?.custom)
                        );
                        const monthlyIncome = valueSFIlVH9i;
                        setIncomeData(valueSFIlVH9i);
                        const valueReDmHyyC = prefillNumberInputs(
                          monthlyIncome,
                          incCatRes,
                          timestampToISO(Constants['STARTING_DATE'])
                        );
                        const numberInputsIncomeRes = valueReDmHyyC;
                        setNumberInputsIncome(valueReDmHyyC);
                        const valueyQ0eeAqe = totalForMonth(
                          numberInputsIncomeRes
                        );
                        const total_income_res = valueyQ0eeAqe;
                        setTotalIncomePerMonth(valueyQ0eeAqe);
                        setGlobalVariableValue({
                          key: 'TOTAL_INCOME',
                          value: total_income_res.slice(0, 12),
                        });
                        setTotalIncomePerCategory(
                          totalForCategory(numberInputsIncomeRes)
                        );

                        const valueEGJTHoK8 = fetchData?.cogs;
                        const categoriesPaymentRes = valueEGJTHoK8;
                        setAllCategoriesPayment(valueEGJTHoK8);
                        const valuenGVxkMoH = sortCategoriesExpense(
                          (fetchData?.operating_expenses).concat(
                            fetchData?.custom_operating_expenses
                          )
                        );
                        const categoriesOperatingRes = valuenGVxkMoH;
                        setAllCategoriesOperating(valuenGVxkMoH);
                        const valuepOrFU59q = sortCategoriesExpense(
                          (fetchData?.finance_expenses).concat(
                            fetchData?.custom_finance_expenses
                          )
                        );
                        const categoriesFinanceRes = valuepOrFU59q;
                        setAllCategoriesFinance(valuepOrFU59q);
                        const valuetAgHaQCo = sortCategoriesExpense(
                          (fetchData?.other_operating_data).concat(
                            fetchData?.custom_other_operating_data
                          )
                        );
                        const categoriesOtherRes = valuetAgHaQCo;
                        setAllCategoriesOther(valuetAgHaQCo);
                        const resExpense = (
                          await DefaultApi.getExpenseGET(Constants, {
                            starting_date: newFormatDate(
                              Constants['STARTING_DATE'],
                              'get'
                            ),
                          })
                        )?.json;

                        const valueCNbKaJXA = [].concat(
                          (resExpense?.cogs?.default).concat(
                            resExpense?.cogs?.custom
                          )
                        );
                        const monthlyPaymentExpense = valueCNbKaJXA;
                        setPaymentData(valueCNbKaJXA);
                        const value3GLlmkfZ = [].concat(
                          (resExpense?.operating_expenses?.default).concat(
                            resExpense?.operating_expenses?.custom
                          )
                        );
                        const monthlyOperatingExpense = value3GLlmkfZ;
                        setOperatingData(value3GLlmkfZ);
                        const valueH6ZzlhKY = [].concat(
                          (resExpense?.finance_expenses?.default).concat(
                            resExpense?.finance_expenses?.custom
                          )
                        );
                        const monthlyFinanceExpense = valueH6ZzlhKY;
                        setFinanceData(valueH6ZzlhKY);
                        const value8Qf3nRdF = [].concat(
                          (resExpense?.other_operating_data?.default).concat(
                            resExpense?.other_operating_data?.custom
                          )
                        );
                        const monthlyOtherExpense = value8Qf3nRdF;
                        setOtherData(value8Qf3nRdF);
                        const value3ejnAZKd = prefillNumberExpense(
                          monthlyPaymentExpense,
                          categoriesPaymentRes,
                          timestampToISO(Constants['STARTING_DATE'])
                        );
                        const niPaymentRes = value3ejnAZKd;
                        setNumberInputsPaymentForCost(value3ejnAZKd);
                        const valueVuXSCUCH = prefillNumberExpense(
                          monthlyOperatingExpense,
                          sortCategoriesExpense(categoriesOperatingRes),
                          timestampToISO(Constants['STARTING_DATE'])
                        );
                        const niOperatingRes = valueVuXSCUCH;
                        setNumberInputsOperating(valueVuXSCUCH);
                        const valuepHylcdxN = prefillNumberExpense(
                          monthlyFinanceExpense,
                          sortCategoriesExpense(categoriesFinanceRes),
                          timestampToISO(Constants['STARTING_DATE'])
                        );
                        const niFinanceRes = valuepHylcdxN;
                        setNumberInputsFinance(valuepHylcdxN);
                        const valuevghOfOH3 = prefillNumberExpense(
                          monthlyOtherExpense,
                          sortCategoriesExpense(categoriesOtherRes),
                          timestampToISO(Constants['STARTING_DATE'])
                        );
                        const niOtherRes = valuevghOfOH3;
                        setNumberInputsOther(valuevghOfOH3);
                        const valuefhYSdsQB = totalForMonth(niPaymentRes);
                        const paymentPerMonth = valuefhYSdsQB;
                        setTotalPaymentForCostPerMonth(valuefhYSdsQB);
                        setTotalPaymentForCostPerCetagory(
                          totalForCategory(niPaymentRes)
                        );

                        const valueGUzJVg9j = totalForMonth(niOperatingRes);
                        const operatingPerMonth = valueGUzJVg9j;
                        setTotalOperatingPerMonth(valueGUzJVg9j);
                        setTotalOperatingPerCategory(
                          totalForCategory(niOperatingRes)
                        );
                        setTotalFinancePerCategory(
                          totalForCategory(niFinanceRes)
                        );

                        const valueOGesai4P = totalForMonth(niFinanceRes);
                        const financePerMonth = valueOGesai4P;
                        setTotalFinancePerMonth(valueOGesai4P);
                        setTotalOtherPerCategory(totalForCategory(niOtherRes));

                        const valueXPTHNi0w = totalCashPaid(
                          totalForMonth(niPaymentRes),
                          totalForMonth(niOperatingRes),
                          totalForMonth(niFinanceRes)
                        );
                        const total_cash_paid = valueXPTHNi0w;
                        setTotalCashPaidOut(valueXPTHNi0w);
                        /* hidden 'Set Variable' action */
                        const new_cash_on_hand = setGlobalVariableValue({
                          key: 'CASH_ON_HAND',
                          value: pullStartingBalance(
                            dataRes?.cash_at_hand,
                            Constants['STARTING_DATE']
                          ).concat([
                            (pullStartingBalance(
                              dataRes?.cash_at_hand,
                              Constants['STARTING_DATE']
                            ) &&
                              pullStartingBalance(
                                dataRes?.cash_at_hand,
                                Constants['STARTING_DATE']
                              )[11]) +
                              (total_income_res && total_income_res[11]) -
                              (total_cash_paid && total_cash_paid[11]),
                          ]),
                        });

                        const values1yPWqPC =
                          new_cash_on_hand && new_cash_on_hand[0];
                        const starting_cash = values1yPWqPC;
                        setStartingCashOn(values1yPWqPC);
                        setTotalCashAvailable(
                          sumArrays(
                            total_income_res.slice(undefined, 12),
                            new_cash_on_hand
                          )
                        );
                        setGlobalVariableValue({
                          key: 'TOTAL_CASH_ON_HAND',
                          value: new_cash_on_hand.slice(1, 13),
                        });
                        setGlobalVariableValue({
                          key: 'TOTAL_CASH_PAID',
                          value: total_cash_paid.slice(0, 12),
                        });
                        setIsLoading(false);
                      } catch (err) {
                        console.error(err);
                      }
                    };
                    handler();
                  },
                }}
              >
                {({ loading, error, data, refetchGetExpenseHeads }) => {
                  const fetchData = data?.json;
                  if (loading) {
                    return <View />;
                  }

                  if (error || data?.status < 200 || data?.status >= 300) {
                    return <ActivityIndicator />;
                  }

                  return (
                    <>
                      {isLoading ? null : (
                        <SimpleStyleScrollView
                          bounces={true}
                          horizontal={false}
                          keyboardShouldPersistTaps={'never'}
                          nestedScrollEnabled={false}
                          showsHorizontalScrollIndicator={true}
                          showsVerticalScrollIndicator={true}
                          style={StyleSheet.applyWidth(
                            {
                              margin: {
                                minWidth: Breakpoints.Laptop,
                                value: 10,
                              },
                            },
                            dimensions.width
                          )}
                        >
                          {/* Bar/Line Chart */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                borderColor: {
                                  minWidth: Breakpoints.Laptop,
                                  value: palettes.App['App Blue Light'],
                                },
                                borderWidth: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 3,
                                },
                                marginTop: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 20,
                                },
                                maxHeight: {
                                  minWidth: Breakpoints.Laptop,
                                  value: '40%',
                                },
                                paddingLeft: {
                                  minWidth: Breakpoints.Laptop,
                                  value: '5%',
                                },
                                paddingRight: {
                                  minWidth: Breakpoints.Laptop,
                                  value: '5%',
                                },
                              },
                              dimensions.width
                            )}
                          >
                            <LinearGradient
                              endX={100}
                              endY={100}
                              startX={0}
                              startY={0}
                              color1={StyleSheet.getWidthValue(
                                [
                                  {
                                    minWidth: Breakpoints.Mobile,
                                    value: palettes.App['Gray Linear Light'],
                                  },
                                  {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.App['Background Light'],
                                  },
                                ],
                                dimensions.width
                              )}
                              color2={StyleSheet.getWidthValue(
                                [
                                  {
                                    minWidth: Breakpoints.Mobile,
                                    value: palettes.App['Gray Linear Dark'],
                                  },
                                  {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand.Background,
                                  },
                                ],
                                dimensions.width
                              )}
                              color3={StyleSheet.getWidthValue(
                                [
                                  {
                                    minWidth: Breakpoints.Mobile,
                                    value: palettes.App['Gray Linear Light'],
                                  },
                                  {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.App['Background Light'],
                                  },
                                ],
                                dimensions.width
                              )}
                              style={StyleSheet.applyWidth(
                                {
                                  bottom: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 0,
                                  },
                                  left: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 0,
                                  },
                                  position: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'absolute',
                                  },
                                  right: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 0,
                                  },
                                  top: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 0,
                                  },
                                },
                                dimensions.width
                              )}
                            />
                            {/* Header */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  alignSelf: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  backgroundColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.Brand['App Blue Dark'],
                                  },
                                  borderColor: {
                                    minWidth: Breakpoints.Laptop,
                                    value: palettes.App['Gray Linear Light'],
                                  },
                                  borderWidth: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 3,
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  marginTop: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 5,
                                  },
                                  padding: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 4,
                                  },
                                  position: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'absolute',
                                  },
                                  zIndex: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 5,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              <LinearGradient
                                color1={theme.colors.branding.primary}
                                color2={theme.colors.branding.secondary}
                                endY={100}
                                startX={0}
                                startY={0}
                                {...GlobalStyles.LinearGradientStyles(theme)[
                                  'Blue Linear'
                                ].props}
                                endX={0}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.LinearGradientStyles(theme)[
                                      'Blue Linear'
                                    ].style,
                                    {
                                      paddingBottom: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 0,
                                      },
                                      paddingTop: {
                                        minWidth: Breakpoints.Laptop,
                                        value: 0,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {/* Header Text */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)['Text']
                                    .props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)['Text']
                                        .style,
                                      {
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: palettes.Brand.Black,
                                        },
                                        fontFamily: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'OpenSans_700Bold',
                                        },
                                        fontSize: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 12,
                                        },
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Cash On hand vs. Expenses'}
                                </Text>
                              </LinearGradient>
                            </View>
                            <Utils.CustomCodeErrorBoundary>
                              <BarChart.App />
                            </Utils.CustomCodeErrorBoundary>
                            {/* Chart Materials View */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 6,
                                  },
                                  height: {
                                    minWidth: Breakpoints.Laptop,
                                    value: '100%',
                                  },
                                  justifyContent: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  position: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'absolute',
                                  },
                                  right: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 0,
                                  },
                                  width: [
                                    {
                                      minWidth: Breakpoints.Laptop,
                                      value: '10%',
                                    },
                                    {
                                      minWidth: Breakpoints.Desktop,
                                      value: '8%',
                                    },
                                    {
                                      minWidth: Breakpoints.BigScreen,
                                      value: '7%',
                                    },
                                  ],
                                },
                                dimensions.width
                              )}
                            >
                              {/* Total Cash Paid Out */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    gap: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 4,
                                    },
                                    width: {
                                      minWidth: Breakpoints.Laptop,
                                      value: '100%',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <Icon
                                  color={palettes.Brand['App Blue Dark']}
                                  name={'Ionicons/square-sharp'}
                                  size={14}
                                />
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)[
                                    'Chart Text White'
                                  ].props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)[
                                        'Chart Text White'
                                      ].style,
                                      {
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: '"rgb(255, 255, 255)"',
                                        },
                                        textAlign: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'left',
                                        },
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Total Cash Paid Out'}
                                </Text>
                              </View>
                              {/* Cash on hand */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    alignItems: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    gap: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 4,
                                    },
                                    width: {
                                      minWidth: Breakpoints.Laptop,
                                      value: '100%',
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                <Icon
                                  color={palettes.Brand['App Green']}
                                  name={'Ionicons/square-sharp'}
                                  size={14}
                                />
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)[
                                    'Chart Text White'
                                  ].props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)[
                                        'Chart Text White'
                                      ].style,
                                      {
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: '"rgb(255, 255, 255)"',
                                        },
                                        textAlign: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 'left',
                                        },
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'Cash on hand (end of month)'}
                                </Text>
                              </View>
                            </View>
                          </View>
                          {/* Middle Info View */}
                          <View
                            style={StyleSheet.applyWidth(
                              {
                                flexDirection: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'row',
                                },
                                justifyContent: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'space-evenly',
                                },
                                paddingBottom: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 10,
                                },
                                paddingTop: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 10,
                                },
                              },
                              dimensions.width
                            )}
                          >
                            {/* Starting Cash On */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  flexDirection: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'row',
                                  },
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: checkScreenMode(Variables)
                                          ? palettes.Brand.White
                                          : palettes.Brand.Black,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Starting cash on hand'}
                              </Text>

                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    borderColor: [
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.White,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: checkScreenMode(Variables)
                                          ? palettes.Brand.White
                                          : palettes.Brand.Black,
                                      },
                                    ],
                                    borderWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    padding: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 4,
                                    },
                                    paddingLeft: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 12,
                                    },
                                    paddingRight: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 12,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Value */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)[
                                    'Chart Text White'
                                  ].props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)[
                                        'Chart Text White'
                                      ].style,
                                      {
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: checkScreenMode(Variables)
                                            ? palettes.Brand.White
                                            : palettes.Brand.Black,
                                        },
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'$ '}
                                  {formatNumber(startingCashOn)}
                                </Text>
                              </View>
                            </View>
                            {/* Starting Date */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  flexDirection: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'row',
                                  },
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: checkScreenMode(Variables)
                                          ? palettes.Brand.White
                                          : palettes.Brand.Black,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Starting Date'}
                              </Text>

                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    borderColor: [
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.White,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: checkScreenMode(Variables)
                                          ? palettes.Brand.White
                                          : palettes.Brand.Black,
                                      },
                                    ],
                                    borderWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    padding: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 4,
                                    },
                                    paddingLeft: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 12,
                                    },
                                    paddingRight: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 12,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Value */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)[
                                    'Chart Text White'
                                  ].props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)[
                                        'Chart Text White'
                                      ].style,
                                      {
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: checkScreenMode(Variables)
                                            ? palettes.Brand.White
                                            : palettes.Brand.Black,
                                        },
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {DateUtils.format(
                                    DateUtils.addDays(
                                      Constants['STARTING_DATE'],
                                      1
                                    ),
                                    'MMM YYYY'
                                  )}
                                </Text>
                              </View>
                            </View>
                            {/* Cash Minimum Balance Alert */}
                            <View
                              style={StyleSheet.applyWidth(
                                {
                                  alignItems: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'center',
                                  },
                                  flexDirection: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 'row',
                                  },
                                  gap: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 12,
                                  },
                                },
                                dimensions.width
                              )}
                            >
                              <Text
                                accessible={true}
                                selectable={false}
                                {...GlobalStyles.TextStyles(theme)[
                                  'Chart Text White'
                                ].props}
                                style={StyleSheet.applyWidth(
                                  StyleSheet.compose(
                                    GlobalStyles.TextStyles(theme)[
                                      'Chart Text White'
                                    ].style,
                                    {
                                      color: {
                                        minWidth: Breakpoints.Laptop,
                                        value: checkScreenMode(Variables)
                                          ? palettes.Brand.White
                                          : palettes.Brand.Black,
                                      },
                                    }
                                  ),
                                  dimensions.width
                                )}
                              >
                                {'Cash minmum balance alert'}
                              </Text>

                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    borderColor: [
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: palettes.Brand.White,
                                      },
                                      {
                                        minWidth: Breakpoints.Laptop,
                                        value: checkScreenMode(Variables)
                                          ? palettes.Brand.White
                                          : palettes.Brand.Black,
                                      },
                                    ],
                                    borderWidth: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 1,
                                    },
                                    padding: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 4,
                                    },
                                    paddingLeft: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 12,
                                    },
                                    paddingRight: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 12,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Value */}
                                <Text
                                  accessible={true}
                                  selectable={false}
                                  {...GlobalStyles.TextStyles(theme)[
                                    'Chart Text White'
                                  ].props}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.TextStyles(theme)[
                                        'Chart Text White'
                                      ].style,
                                      {
                                        color: {
                                          minWidth: Breakpoints.Laptop,
                                          value: checkScreenMode(Variables)
                                            ? palettes.Brand.White
                                            : palettes.Brand.Black,
                                        },
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {'$ '}
                                  {formatNumber(Constants['BALANCE_ALERT'])}
                                </Text>
                              </View>
                            </View>
                          </View>

                          <SimpleStyleScrollView
                            bounces={true}
                            keyboardShouldPersistTaps={'never'}
                            nestedScrollEnabled={false}
                            showsHorizontalScrollIndicator={true}
                            showsVerticalScrollIndicator={true}
                            horizontal={true}
                            style={StyleSheet.applyWidth(
                              {
                                paddingBottom: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 20,
                                },
                              },
                              dimensions.width
                            )}
                          >
                            {/* Table */}
                            <View>
                              {/* Header 1 */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    height: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 25,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Month */}
                                <LinearGradient
                                  endY={100}
                                  startX={0}
                                  startY={0}
                                  {...GlobalStyles.LinearGradientStyles(theme)[
                                    'Blue Linear'
                                  ].props}
                                  color1={palettes.Brand['App Blue Dark']}
                                  color2={palettes.App['App Blue Light']}
                                  color3={palettes.Brand['App Blue Dark']}
                                  endX={0}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.LinearGradientStyles(theme)[
                                        'Blue Linear'
                                      ].style,
                                      {
                                        borderBottomWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 1,
                                        },
                                        borderColor: {
                                          minWidth: Breakpoints.Laptop,
                                          value: palettes.Brand.White,
                                        },
                                        borderLeftWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 1,
                                        },
                                        maxWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 300,
                                        },
                                        minWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 300,
                                        },
                                        width: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 300,
                                        },
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {/* Month */}
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      GlobalStyles.TextStyles(theme)[
                                        'Chart Text'
                                      ].style,
                                      dimensions.width
                                    )}
                                  >
                                    {'Month'}
                                  </Text>
                                </LinearGradient>
                                {/* Months List */}
                                <SimpleStyleFlatList
                                  data={generateDates(
                                    Constants['STARTING_DATE']
                                  )
                                    .concat('Ending Balance')
                                    .concat('%')}
                                  decelerationRate={'normal'}
                                  inverted={false}
                                  keyExtractor={(monthsListData, index) =>
                                    monthsListData?.id ??
                                    monthsListData?.uuid ??
                                    index?.toString() ??
                                    JSON.stringify(monthsListData)
                                  }
                                  keyboardShouldPersistTaps={'never'}
                                  listKey={'fjV8pkdd'}
                                  nestedScrollEnabled={false}
                                  numColumns={1}
                                  onEndReachedThreshold={0.5}
                                  pagingEnabled={false}
                                  renderItem={({ item, index }) => {
                                    const monthsListData = item;
                                    return (
                                      <>
                                        {/* Months Gradient */}
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          {...GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].props}
                                          color1={
                                            palettes.Brand['App Blue Dark']
                                          }
                                          color2={
                                            palettes.App['App Blue Light']
                                          }
                                          color3={
                                            palettes.Brand['App Blue Dark']
                                          }
                                          endX={0}
                                          style={StyleSheet.applyWidth(
                                            StyleSheet.compose(
                                              GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].style,
                                              {
                                                borderBottomWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.White,
                                                },
                                                borderLeftWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                minWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 75,
                                                },
                                                width: [
                                                  {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 75,
                                                  },
                                                  {
                                                    minWidth:
                                                      Breakpoints.BigScreen,
                                                    value:
                                                      (dimensions.width -
                                                        dimensions.width *
                                                          (15 / 100) -
                                                        320) /
                                                      14,
                                                  },
                                                ],
                                              }
                                            ),
                                            dimensions.width
                                          )}
                                        >
                                          {/* Months Text */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              GlobalStyles.TextStyles(theme)[
                                                'Chart Text'
                                              ].style,
                                              dimensions.width
                                            )}
                                          >
                                            {monthsListData}
                                          </Text>
                                        </LinearGradient>
                                      </>
                                    );
                                  }}
                                  showsVerticalScrollIndicator={true}
                                  snapToAlignment={'start'}
                                  horizontal={true}
                                  scrollEnabled={false}
                                  showsHorizontalScrollIndicator={false}
                                />
                              </View>
                              {/* Header 2 */}
                              <View
                                style={StyleSheet.applyWidth(
                                  {
                                    flexDirection: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'row',
                                    },
                                    height: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 25,
                                    },
                                  },
                                  dimensions.width
                                )}
                              >
                                {/* Cash On Hand (begining of the month) */}
                                <LinearGradient
                                  endY={100}
                                  startX={0}
                                  startY={0}
                                  {...GlobalStyles.LinearGradientStyles(theme)[
                                    'Blue Linear'
                                  ].props}
                                  color1={palettes.Brand['App Blue Dark']}
                                  color2={palettes.App['App Blue Light']}
                                  color3={palettes.Brand['App Blue Dark']}
                                  endX={0}
                                  style={StyleSheet.applyWidth(
                                    StyleSheet.compose(
                                      GlobalStyles.LinearGradientStyles(theme)[
                                        'Blue Linear'
                                      ].style,
                                      {
                                        borderBottomWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 1,
                                        },
                                        borderColor: {
                                          minWidth: Breakpoints.Laptop,
                                          value: palettes.Brand.White,
                                        },
                                        borderLeftWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 1,
                                        },
                                        maxWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 300,
                                        },
                                        minWidth: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 300,
                                        },
                                        width: {
                                          minWidth: Breakpoints.Laptop,
                                          value: 300,
                                        },
                                      }
                                    ),
                                    dimensions.width
                                  )}
                                >
                                  {/* Cash On Hand (begining of the month) */}
                                  <Text
                                    accessible={true}
                                    selectable={false}
                                    {...GlobalStyles.TextStyles(theme)[
                                      'Chart Text'
                                    ].props}
                                    style={StyleSheet.applyWidth(
                                      GlobalStyles.TextStyles(theme)[
                                        'Chart Text'
                                      ].style,
                                      dimensions.width
                                    )}
                                  >
                                    {'Cash on hand (beginning of the month)'}
                                  </Text>
                                </LinearGradient>
                                {/* Cash On Hand */}
                                <SimpleStyleFlatList
                                  data={Constants['CASH_ON_HAND'].concat([''])}
                                  decelerationRate={'normal'}
                                  inverted={false}
                                  keyExtractor={(cashOnHandData, index) =>
                                    cashOnHandData?.id ??
                                    cashOnHandData?.uuid ??
                                    index?.toString() ??
                                    JSON.stringify(cashOnHandData)
                                  }
                                  keyboardShouldPersistTaps={'never'}
                                  listKey={'36KeTSTh'}
                                  nestedScrollEnabled={false}
                                  numColumns={1}
                                  onEndReachedThreshold={0.5}
                                  pagingEnabled={false}
                                  renderItem={({ item, index }) => {
                                    const cashOnHandData = item;
                                    return (
                                      <>
                                        {/* Cash On Hand */}
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          {...GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].props}
                                          color1={
                                            palettes.Brand['App Blue Dark']
                                          }
                                          color2={
                                            palettes.App['App Blue Light']
                                          }
                                          color3={
                                            palettes.Brand['App Blue Dark']
                                          }
                                          endX={0}
                                          style={StyleSheet.applyWidth(
                                            StyleSheet.compose(
                                              GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].style,
                                              {
                                                borderBottomWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.White,
                                                },
                                                borderLeftWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                minWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 75,
                                                },
                                                width: [
                                                  {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 75,
                                                  },
                                                  {
                                                    minWidth:
                                                      Breakpoints.BigScreen,
                                                    value:
                                                      (dimensions.width -
                                                        dimensions.width *
                                                          (15 / 100) -
                                                        320) /
                                                      14,
                                                  },
                                                ],
                                              }
                                            ),
                                            dimensions.width
                                          )}
                                        >
                                          {/* $ */}
                                          <>
                                            {!(index < 12) ? null : (
                                              <Text
                                                accessible={true}
                                                selectable={false}
                                                {...GlobalStyles.TextStyles(
                                                  theme
                                                )['Chart Text'].props}
                                                style={StyleSheet.applyWidth(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  dimensions.width
                                                )}
                                              >
                                                {'$'}
                                              </Text>
                                            )}
                                          </>
                                          {/* Value */}
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              GlobalStyles.TextStyles(theme)[
                                                'Chart Text'
                                              ].style,
                                              dimensions.width
                                            )}
                                          >
                                            {index < 13
                                              ? formatNumber(cashOnHandData)
                                              : cashOnHandData}
                                          </Text>
                                        </LinearGradient>
                                      </>
                                    );
                                  }}
                                  showsVerticalScrollIndicator={true}
                                  snapToAlignment={'start'}
                                  horizontal={true}
                                  scrollEnabled={false}
                                  showsHorizontalScrollIndicator={false}
                                />
                              </View>
                              {/* Table Main */}
                              <View>
                                {/* Fetch Loaded */}
                                <View>
                                  {/* Income */}
                                  <View>
                                    {/* Header View */}
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          padding: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 6,
                                          },
                                          width: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 300,
                                          },
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      {/* Income Header */}
                                      <Text
                                        accessible={true}
                                        selectable={false}
                                        {...GlobalStyles.TextStyles(theme)[
                                          'Header'
                                        ].props}
                                        style={StyleSheet.applyWidth(
                                          StyleSheet.compose(
                                            GlobalStyles.TextStyles(theme)[
                                              'Header'
                                            ].style,
                                            {
                                              color: {
                                                minWidth: Breakpoints.Laptop,
                                                value: checkScreenMode(
                                                  Variables
                                                )
                                                  ? palettes.Brand.White
                                                  : palettes.Brand.Black,
                                              },
                                              fontSize: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 18,
                                              },
                                              textAlign: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'right',
                                              },
                                            }
                                          ),
                                          dimensions.width
                                        )}
                                      >
                                        {'Income'}
                                      </Text>
                                    </View>
                                    {/* Categories */}
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          borderTopWidth: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 1,
                                          },
                                          flexDirection: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 'row',
                                          },
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      {/* Left */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            backgroundColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: checkScreenMode(Variables)
                                                ? undefined
                                                : palettes.Brand.White,
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Categories List */}
                                        <SimpleStyleFlatList
                                          data={incomeCategories}
                                          decelerationRate={'normal'}
                                          horizontal={false}
                                          inverted={false}
                                          keyExtractor={(
                                            categoriesListData,
                                            index
                                          ) =>
                                            categoriesListData?.id ??
                                            categoriesListData?.uuid ??
                                            index?.toString() ??
                                            JSON.stringify(categoriesListData)
                                          }
                                          keyboardShouldPersistTaps={'never'}
                                          listKey={'y0ug9E9e'}
                                          nestedScrollEnabled={false}
                                          numColumns={1}
                                          onEndReachedThreshold={0.5}
                                          pagingEnabled={false}
                                          renderItem={({ item, index }) => {
                                            const categoriesListData = item;
                                            return (
                                              <>
                                                {/* Categories */}
                                                <View
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      flexDirection: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'row',
                                                      },
                                                      width: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: '100%',
                                                      },
                                                    },
                                                    dimensions.width
                                                  )}
                                                >
                                                  <LinearGradient
                                                    endY={100}
                                                    color1={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Light'
                                                      ]
                                                    }
                                                    color2={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    startX={0}
                                                    startY={0}
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        alignItems: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'center',
                                                        },
                                                        borderBottomWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        borderColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            palettes.Brand
                                                              .Black,
                                                        },
                                                        borderLeftWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        borderRightWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        flexDirection: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'row',
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        justifyContent: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'flex-end',
                                                        },
                                                        maxHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        maxWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                        minHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 300,
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Categories Text */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .White
                                                                  : palettes
                                                                      .Brand
                                                                      .Black,
                                                            },
                                                            paddingLeft: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 4,
                                                            },
                                                            paddingRight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 4,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {categoriesListData?.default_value
                                                        ? categoriesListData
                                                            ?._income_heads
                                                            ?.title
                                                        : categoriesListData?.title}
                                                    </Text>
                                                  </LinearGradient>
                                                  <SimpleStyleFlatList
                                                    data={[
                                                      1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                      10, 11, 12,
                                                    ]}
                                                    decelerationRate={'normal'}
                                                    inverted={false}
                                                    keyExtractor={(
                                                      listData,
                                                      index
                                                    ) =>
                                                      listData?.id ??
                                                      listData?.uuid ??
                                                      index?.toString() ??
                                                      JSON.stringify(listData)
                                                    }
                                                    keyboardShouldPersistTaps={
                                                      'never'
                                                    }
                                                    listKey={JSON.stringify([
                                                      1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                      10, 11, 12,
                                                    ])}
                                                    nestedScrollEnabled={false}
                                                    numColumns={1}
                                                    onEndReachedThreshold={0.5}
                                                    pagingEnabled={false}
                                                    renderItem={({
                                                      item,
                                                      index,
                                                    }) => {
                                                      const listData = item;
                                                      return (
                                                        <LinearGradient
                                                          endY={100}
                                                          startX={0}
                                                          startY={0}
                                                          color1={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .Background
                                                              : palettes.App[
                                                                  'Light Linear - Dark'
                                                                ]) ??
                                                            theme.colors
                                                              .branding.primary
                                                          }
                                                          color2={
                                                            (checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.App[
                                                                  'Gray Linear Dark'
                                                                ]
                                                              : palettes.App[
                                                                  'Light Linear - Light'
                                                                ]) ??
                                                            theme.colors
                                                              .branding
                                                              .secondary
                                                          }
                                                          color3={
                                                            checkScreenMode(
                                                              Variables
                                                            )
                                                              ? palettes.Brand
                                                                  .Background
                                                              : palettes.App[
                                                                  'Light Linear - Dark'
                                                                ]
                                                          }
                                                          endX={0}
                                                          style={StyleSheet.applyWidth(
                                                            {
                                                              alignItems: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 'center',
                                                              },
                                                              borderBottomWidth:
                                                                {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              borderColor: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  palettes.Brand
                                                                    .Black,
                                                              },
                                                              borderRightWidth:
                                                                {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 1,
                                                                },
                                                              height: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 25,
                                                              },
                                                              justifyContent: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 'center',
                                                              },
                                                              maxHeight: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 25,
                                                              },
                                                              minHeight: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 25,
                                                              },
                                                              minWidth: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 75,
                                                              },
                                                              width: [
                                                                {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 75,
                                                                },
                                                                {
                                                                  minWidth:
                                                                    Breakpoints.BigScreen,
                                                                  value:
                                                                    (dimensions.width -
                                                                      dimensions.width *
                                                                        (15 /
                                                                          100) -
                                                                      320) /
                                                                    14,
                                                                },
                                                              ],
                                                            },
                                                            dimensions.width
                                                          )}
                                                        >
                                                          <Text
                                                            accessible={true}
                                                            selectable={false}
                                                            {...GlobalStyles.TextStyles(
                                                              theme
                                                            )[
                                                              'Chart Text White'
                                                            ].props}
                                                            style={StyleSheet.applyWidth(
                                                              StyleSheet.compose(
                                                                GlobalStyles.TextStyles(
                                                                  theme
                                                                )[
                                                                  'Chart Text White'
                                                                ].style,
                                                                {
                                                                  color: {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      Constants[
                                                                        'SWITCH_SCREEN_MODE'
                                                                      ]
                                                                        ? palettes
                                                                            .Brand
                                                                            .Black
                                                                        : palettes
                                                                            .Brand
                                                                            .White,
                                                                  },
                                                                }
                                                              ),
                                                              dimensions.width
                                                            )}
                                                          >
                                                            {'$ '}
                                                            {formatNumber(
                                                              getInitValue(
                                                                numberInputsIncome,
                                                                findIndextAllCategories(
                                                                  sortCategories(
                                                                    incomeCategories
                                                                  ),
                                                                  categoriesListData
                                                                ),
                                                                index
                                                              )
                                                            )}
                                                          </Text>
                                                        </LinearGradient>
                                                      );
                                                    }}
                                                    showsHorizontalScrollIndicator={
                                                      true
                                                    }
                                                    showsVerticalScrollIndicator={
                                                      true
                                                    }
                                                    snapToAlignment={'start'}
                                                    horizontal={true}
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        flex: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  />
                                                </View>
                                              </>
                                            );
                                          }}
                                          showsHorizontalScrollIndicator={true}
                                          showsVerticalScrollIndicator={true}
                                          snapToAlignment={'start'}
                                          style={StyleSheet.applyWidth(
                                            {
                                              flex: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        />
                                      </View>
                                      {/* Right */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            flexDirection: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'row',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        <SimpleStyleFlatList
                                          data={totalIncomePerCategory}
                                          decelerationRate={'normal'}
                                          horizontal={false}
                                          inverted={false}
                                          keyExtractor={(listData, index) =>
                                            listData?.id ??
                                            listData?.uuid ??
                                            index?.toString() ??
                                            JSON.stringify(listData)
                                          }
                                          keyboardShouldPersistTaps={'never'}
                                          listKey={'sFv8s5xH'}
                                          nestedScrollEnabled={false}
                                          numColumns={1}
                                          onEndReachedThreshold={0.5}
                                          pagingEnabled={false}
                                          renderItem={({ item, index }) => {
                                            const listData = item;
                                            return (
                                              <>
                                                {/* Total Gradiant */}
                                                <LinearGradient
                                                  endY={100}
                                                  startX={0}
                                                  startY={0}
                                                  color1={
                                                    checkScreenMode(Variables)
                                                      ? palettes.App[
                                                          'Gray Linear Light'
                                                        ]
                                                      : palettes.App[
                                                          'Light Linear - Light'
                                                        ]
                                                  }
                                                  color2={
                                                    checkScreenMode(Variables)
                                                      ? palettes.App[
                                                          'Gray Linear Dark'
                                                        ]
                                                      : palettes.App[
                                                          'Light Linear - Dark'
                                                        ]
                                                  }
                                                  color3={null}
                                                  endX={0}
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      alignItems: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'center',
                                                      },
                                                      borderBottomWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      borderRightWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      borderTopWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                      height: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      justifyContent: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'center',
                                                      },
                                                      maxHeight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      minHeight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      minWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 75,
                                                      },
                                                      width: [
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 75,
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.BigScreen,
                                                          value:
                                                            (dimensions.width -
                                                              dimensions.width *
                                                                (15 / 100) -
                                                              320) /
                                                            14,
                                                        },
                                                      ],
                                                    },
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Total Value */}
                                                  <Text
                                                    accessible={true}
                                                    selectable={false}
                                                    {...GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].props}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text White']
                                                          .style,
                                                        {
                                                          color: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .White
                                                                : palettes.Brand
                                                                    .Black,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {'$ '}
                                                    {formatNumber(listData)}
                                                  </Text>
                                                </LinearGradient>
                                              </>
                                            );
                                          }}
                                          showsHorizontalScrollIndicator={true}
                                          showsVerticalScrollIndicator={true}
                                          snapToAlignment={'start'}
                                        />
                                        {/* List 2 */}
                                        <SimpleStyleFlatList
                                          data={calculateBenchmark(
                                            totalIncomePerCategory
                                          )}
                                          decelerationRate={'normal'}
                                          horizontal={false}
                                          inverted={false}
                                          keyExtractor={(list2Data, index) =>
                                            list2Data?.id ??
                                            list2Data?.uuid ??
                                            index?.toString() ??
                                            JSON.stringify(list2Data)
                                          }
                                          keyboardShouldPersistTaps={'never'}
                                          listKey={'9B21YPJf'}
                                          nestedScrollEnabled={false}
                                          numColumns={1}
                                          onEndReachedThreshold={0.5}
                                          pagingEnabled={false}
                                          renderItem={({ item, index }) => {
                                            const list2Data = item;
                                            return (
                                              <>
                                                {/* Benchmarks */}
                                                <LinearGradient
                                                  endY={100}
                                                  startX={0}
                                                  startY={0}
                                                  color1={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.App[
                                                          'Gray Linear Light'
                                                        ]
                                                      : palettes.App[
                                                          'Light Linear - Light'
                                                        ]) ??
                                                    palettes.App[
                                                      'Gray Linear Light'
                                                    ]
                                                  }
                                                  color2={
                                                    (checkScreenMode(Variables)
                                                      ? palettes.App[
                                                          'Gray Linear Dark'
                                                        ]
                                                      : palettes.App[
                                                          'Light Linear - Dark'
                                                        ]) ??
                                                    palettes.App[
                                                      'Gray Linear Dark'
                                                    ]
                                                  }
                                                  color3={null}
                                                  endX={0}
                                                  style={StyleSheet.applyWidth(
                                                    {
                                                      alignItems: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'center',
                                                      },
                                                      borderBottomWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      borderTopWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 0,
                                                      },
                                                      flex: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: null,
                                                      },
                                                      height: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      justifyContent: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 'center',
                                                      },
                                                      maxHeight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      maxWidth: {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value: null,
                                                      },
                                                      minHeight: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 25,
                                                      },
                                                      minWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 75,
                                                      },
                                                      width: [
                                                        {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 75,
                                                        },
                                                        {
                                                          minWidth:
                                                            Breakpoints.BigScreen,
                                                          value:
                                                            (dimensions.width -
                                                              dimensions.width *
                                                                (15 / 100) -
                                                              320) /
                                                            14,
                                                        },
                                                      ],
                                                    },
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Benchmarks */}
                                                  <Text
                                                    accessible={true}
                                                    selectable={false}
                                                    {...GlobalStyles.TextStyles(
                                                      theme
                                                    )['Chart Text White'].props}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text White']
                                                          .style,
                                                        {
                                                          color: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .White
                                                                : palettes.Brand
                                                                    .Black,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {formatPercentage(
                                                      list2Data
                                                    )}
                                                  </Text>
                                                </LinearGradient>
                                              </>
                                            );
                                          }}
                                          showsHorizontalScrollIndicator={true}
                                          showsVerticalScrollIndicator={true}
                                          snapToAlignment={'start'}
                                        />
                                      </View>
                                    </View>
                                    {/* Bottom Total */}
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          borderColor: {
                                            minWidth: Breakpoints.Laptop,
                                            value: palettes.Brand.Black,
                                          },
                                          bottom: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 0,
                                          },
                                          width: {
                                            minWidth: Breakpoints.Laptop,
                                            value: '100%',
                                          },
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      {/* Total Income */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            flex: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            flexDirection: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'row',
                                            },
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          {...GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].props}
                                          color1={
                                            palettes.Brand['App Blue Dark']
                                          }
                                          color2={
                                            palettes.App['App Blue Light']
                                          }
                                          color3={
                                            palettes.Brand['App Blue Dark']
                                          }
                                          endX={0}
                                          style={StyleSheet.applyWidth(
                                            StyleSheet.compose(
                                              GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].style,
                                              {
                                                borderBottomWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.White,
                                                },
                                                borderRightWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                justifyContent: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'flex-end',
                                                },
                                                maxWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                                minWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                              }
                                            ),
                                            dimensions.width
                                          )}
                                        >
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Chart Text'
                                                ].style,
                                                {
                                                  paddingRight: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 4,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Total Income'}
                                          </Text>
                                        </LinearGradient>
                                        {/* Total Income */}
                                        <SimpleStyleFlatList
                                          data={totalIncomePerMonth.concat([
                                            '100.00%',
                                          ])}
                                          decelerationRate={'normal'}
                                          inverted={false}
                                          keyExtractor={(
                                            totalIncomeData,
                                            index
                                          ) =>
                                            totalIncomeData?.id ??
                                            totalIncomeData?.uuid ??
                                            index?.toString() ??
                                            JSON.stringify(totalIncomeData)
                                          }
                                          keyboardShouldPersistTaps={'never'}
                                          listKey={'JVW2hGsx'}
                                          nestedScrollEnabled={false}
                                          numColumns={1}
                                          onEndReachedThreshold={0.5}
                                          pagingEnabled={false}
                                          renderItem={({ item, index }) => {
                                            const totalIncomeData = item;
                                            return (
                                              <>
                                                {/* Total Income */}
                                                <LinearGradient
                                                  endY={100}
                                                  startX={0}
                                                  startY={0}
                                                  {...GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].props}
                                                  color1={
                                                    palettes.Brand[
                                                      'App Blue Dark'
                                                    ]
                                                  }
                                                  color2={
                                                    palettes.App[
                                                      'App Blue Light'
                                                    ]
                                                  }
                                                  color3={
                                                    palettes.Brand[
                                                      'App Blue Dark'
                                                    ]
                                                  }
                                                  endX={0}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.LinearGradientStyles(
                                                        theme
                                                      )['Blue Linear'].style,
                                                      {
                                                        borderBottomWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        borderColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            palettes.Brand
                                                              .White,
                                                        },
                                                        borderRightWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        minWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 75,
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.BigScreen,
                                                          value:
                                                            (dimensions.width -
                                                              dimensions.width *
                                                                (15 / 100) -
                                                              320) /
                                                            14,
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Total Income */}
                                                  <>
                                                    {!(index < 13) ? null : (
                                                      <Text
                                                        accessible={true}
                                                        selectable={false}
                                                        {...GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text'].props}
                                                        style={StyleSheet.applyWidth(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].style,
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {'$ '}
                                                        {formatNumber(
                                                          totalIncomeData
                                                        )}
                                                      </Text>
                                                    )}
                                                  </>
                                                  {/* Benchmark */}
                                                  <>
                                                    {!(index > 12) ? null : (
                                                      <Text
                                                        accessible={true}
                                                        selectable={false}
                                                        {...GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text'].props}
                                                        style={StyleSheet.applyWidth(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].style,
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {totalIncomeData}
                                                      </Text>
                                                    )}
                                                  </>
                                                </LinearGradient>
                                              </>
                                            );
                                          }}
                                          showsVerticalScrollIndicator={true}
                                          snapToAlignment={'start'}
                                          horizontal={true}
                                          scrollEnabled={false}
                                          showsHorizontalScrollIndicator={false}
                                        />
                                      </View>
                                      {/* Total Cash Available */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            flex: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            flexDirection: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'row',
                                            },
                                            height: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 25,
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Linear Gradient 2 */}
                                        <LinearGradient
                                          endY={100}
                                          startX={0}
                                          startY={0}
                                          {...GlobalStyles.LinearGradientStyles(
                                            theme
                                          )['Blue Linear'].props}
                                          color1={
                                            palettes.Brand['App Blue Dark']
                                          }
                                          color2={
                                            palettes.App['App Blue Light']
                                          }
                                          color3={
                                            palettes.Brand['App Blue Dark']
                                          }
                                          endX={0}
                                          style={StyleSheet.applyWidth(
                                            StyleSheet.compose(
                                              GlobalStyles.LinearGradientStyles(
                                                theme
                                              )['Blue Linear'].style,
                                              {
                                                borderColor: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: palettes.Brand.White,
                                                },
                                                borderRightWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                                justifyContent: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'flex-end',
                                                },
                                                maxWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                                minWidth: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 300,
                                                },
                                              }
                                            ),
                                            dimensions.width
                                          )}
                                        >
                                          <Text
                                            accessible={true}
                                            selectable={false}
                                            {...GlobalStyles.TextStyles(theme)[
                                              'Chart Text'
                                            ].props}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.TextStyles(theme)[
                                                  'Chart Text'
                                                ].style,
                                                {
                                                  paddingRight: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 4,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            {'Total Cash Available'}
                                          </Text>
                                        </LinearGradient>
                                        {/* Total Cash Available */}
                                        <SimpleStyleFlatList
                                          data={totalCashAvailable.concat([
                                            '',
                                            '',
                                          ])}
                                          decelerationRate={'normal'}
                                          inverted={false}
                                          keyExtractor={(
                                            totalCashAvailableData,
                                            index
                                          ) =>
                                            totalCashAvailableData?.id ??
                                            totalCashAvailableData?.uuid ??
                                            index?.toString() ??
                                            JSON.stringify(
                                              totalCashAvailableData
                                            )
                                          }
                                          keyboardShouldPersistTaps={'never'}
                                          listKey={'7Ns7iauR'}
                                          nestedScrollEnabled={false}
                                          numColumns={1}
                                          onEndReachedThreshold={0.5}
                                          pagingEnabled={false}
                                          renderItem={({ item, index }) => {
                                            const totalCashAvailableData = item;
                                            return (
                                              <>
                                                {/* Total Income */}
                                                <LinearGradient
                                                  endY={100}
                                                  startX={0}
                                                  startY={0}
                                                  {...GlobalStyles.LinearGradientStyles(
                                                    theme
                                                  )['Blue Linear'].props}
                                                  color1={
                                                    palettes.Brand[
                                                      'App Blue Dark'
                                                    ]
                                                  }
                                                  color2={
                                                    palettes.App[
                                                      'App Blue Light'
                                                    ]
                                                  }
                                                  color3={
                                                    palettes.Brand[
                                                      'App Blue Dark'
                                                    ]
                                                  }
                                                  endX={0}
                                                  style={StyleSheet.applyWidth(
                                                    StyleSheet.compose(
                                                      GlobalStyles.LinearGradientStyles(
                                                        theme
                                                      )['Blue Linear'].style,
                                                      {
                                                        borderColor: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value:
                                                            palettes.Brand
                                                              .White,
                                                        },
                                                        borderRightWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        minWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 75,
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.BigScreen,
                                                          value:
                                                            (dimensions.width -
                                                              dimensions.width *
                                                                (15 / 100) -
                                                              320) /
                                                            14,
                                                        },
                                                      }
                                                    ),
                                                    dimensions.width
                                                  )}
                                                >
                                                  {/* Total Income */}
                                                  <>
                                                    {!(index < 12) ? null : (
                                                      <Text
                                                        accessible={true}
                                                        selectable={false}
                                                        {...GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text'].props}
                                                        style={StyleSheet.applyWidth(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].style,
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {'$ '}
                                                        {formatNumber(
                                                          totalCashAvailableData
                                                        )}
                                                      </Text>
                                                    )}
                                                  </>
                                                </LinearGradient>
                                              </>
                                            );
                                          }}
                                          showsVerticalScrollIndicator={true}
                                          snapToAlignment={'start'}
                                          horizontal={true}
                                          scrollEnabled={false}
                                          showsHorizontalScrollIndicator={false}
                                        />
                                      </View>
                                    </View>
                                  </View>
                                  {/* Expense */}
                                  <View>
                                    {/* Product Payments */}
                                    <View
                                      style={StyleSheet.applyWidth(
                                        {
                                          borderBottomWidth: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 1,
                                          },
                                          borderColor: {
                                            minWidth: Breakpoints.Laptop,
                                            value: palettes.Brand.White,
                                          },
                                          flex: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 1,
                                          },
                                          flexDirection: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 'row',
                                          },
                                          height: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 25,
                                          },
                                          marginTop: {
                                            minWidth: Breakpoints.Laptop,
                                            value: 25,
                                          },
                                        },
                                        dimensions.width
                                      )}
                                    >
                                      {/* Linear Gradient 2 */}
                                      <LinearGradient
                                        endY={100}
                                        startX={0}
                                        startY={0}
                                        {...GlobalStyles.LinearGradientStyles(
                                          theme
                                        )['Blue Linear'].props}
                                        color1={palettes.Brand['App Blue Dark']}
                                        color2={palettes.App['App Blue Light']}
                                        color3={palettes.Brand['App Blue Dark']}
                                        endX={0}
                                        style={StyleSheet.applyWidth(
                                          StyleSheet.compose(
                                            GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Blue Linear'].style,
                                            {
                                              borderColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.White,
                                              },
                                              borderRightWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              justifyContent: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'flex-end',
                                              },
                                              maxWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                              minWidth: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 300,
                                              },
                                            }
                                          ),
                                          dimensions.width
                                        )}
                                      >
                                        <Text
                                          accessible={true}
                                          selectable={false}
                                          {...GlobalStyles.TextStyles(theme)[
                                            'Chart Text'
                                          ].props}
                                          style={StyleSheet.applyWidth(
                                            StyleSheet.compose(
                                              GlobalStyles.TextStyles(theme)[
                                                'Chart Text'
                                              ].style,
                                              {
                                                paddingRight: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 4,
                                                },
                                              }
                                            ),
                                            dimensions.width
                                          )}
                                        >
                                          {'Product Payments'}
                                        </Text>
                                      </LinearGradient>
                                      {/* Product Payments */}
                                      <SimpleStyleFlatList
                                        data={totalPaymentForCostPerMonth.concat(
                                          calculatePercentIncome(
                                            totalIncomePerMonth.slice(0, 12),
                                            totalPaymentForCostPerMonth.slice(
                                              12,
                                              undefined
                                            )
                                          )
                                        )}
                                        decelerationRate={'normal'}
                                        inverted={false}
                                        keyExtractor={(
                                          productPaymentsData,
                                          index
                                        ) =>
                                          productPaymentsData?.id ??
                                          productPaymentsData?.uuid ??
                                          index?.toString() ??
                                          JSON.stringify(productPaymentsData)
                                        }
                                        keyboardShouldPersistTaps={'never'}
                                        listKey={'MVAyn9xH'}
                                        nestedScrollEnabled={false}
                                        numColumns={1}
                                        onEndReachedThreshold={0.5}
                                        pagingEnabled={false}
                                        renderItem={({ item, index }) => {
                                          const productPaymentsData = item;
                                          return (
                                            <>
                                              {/* Product Payments */}
                                              <LinearGradient
                                                endY={100}
                                                startX={0}
                                                startY={0}
                                                {...GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].props}
                                                color1={
                                                  palettes.Brand[
                                                    'App Blue Dark'
                                                  ]
                                                }
                                                color2={
                                                  palettes.App['App Blue Light']
                                                }
                                                color3={
                                                  palettes.Brand[
                                                    'App Blue Dark'
                                                  ]
                                                }
                                                endX={0}
                                                style={StyleSheet.applyWidth(
                                                  StyleSheet.compose(
                                                    GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].style,
                                                    {
                                                      borderColor: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value:
                                                          palettes.Brand.White,
                                                      },
                                                      borderRightWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 1,
                                                      },
                                                      minWidth: {
                                                        minWidth:
                                                          Breakpoints.Laptop,
                                                        value: 75,
                                                      },
                                                      width: {
                                                        minWidth:
                                                          Breakpoints.BigScreen,
                                                        value:
                                                          (dimensions.width -
                                                            dimensions.width *
                                                              (15 / 100) -
                                                            320) /
                                                          14,
                                                      },
                                                    }
                                                  ),
                                                  dimensions.width
                                                )}
                                              >
                                                {/* Product Payments */}
                                                <>
                                                  {!(index < 13) ? null : (
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text'].props}
                                                      style={StyleSheet.applyWidth(
                                                        GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text'].style,
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {'$ '}
                                                      {formatNumber(
                                                        productPaymentsData
                                                      )}
                                                    </Text>
                                                  )}
                                                </>
                                                {/* Product Payments 2 */}
                                                <>
                                                  {!(index === 13) ? null : (
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text'].props}
                                                      style={StyleSheet.applyWidth(
                                                        GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text'].style,
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {formatPercentage(
                                                        productPaymentsData
                                                      )}
                                                    </Text>
                                                  )}
                                                </>
                                              </LinearGradient>
                                            </>
                                          );
                                        }}
                                        showsVerticalScrollIndicator={true}
                                        snapToAlignment={'start'}
                                        horizontal={true}
                                        scrollEnabled={false}
                                        showsHorizontalScrollIndicator={false}
                                      />
                                    </View>
                                    {/* Operating Expenses */}
                                    <View>
                                      {/* Header View */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            padding: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 6,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Header */}
                                        <Text
                                          accessible={true}
                                          selectable={false}
                                          {...GlobalStyles.TextStyles(theme)[
                                            'Header'
                                          ].props}
                                          style={StyleSheet.applyWidth(
                                            StyleSheet.compose(
                                              GlobalStyles.TextStyles(theme)[
                                                'Header'
                                              ].style,
                                              {
                                                color: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: checkScreenMode(
                                                    Variables
                                                  )
                                                    ? palettes.Brand.White
                                                    : palettes.Brand.Black,
                                                },
                                                fontSize: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 18,
                                                },
                                                textAlign: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'right',
                                                },
                                              }
                                            ),
                                            dimensions.width
                                          )}
                                        >
                                          {'Operating Expenses'}
                                        </Text>
                                      </View>
                                      {/* Categories */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            borderTopWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            flexDirection: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'row',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Left */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              backgroundColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: checkScreenMode(
                                                  Variables
                                                )
                                                  ? undefined
                                                  : palettes.Brand.White,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Categories List */}
                                          <SimpleStyleFlatList
                                            data={allCategoriesOperating}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(
                                              categoriesListData,
                                              index
                                            ) =>
                                              categoriesListData?.id ??
                                              categoriesListData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(categoriesListData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'BH5OzPDc'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const categoriesListData = item;
                                              return (
                                                <>
                                                  {/* Categories */}
                                                  <View
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        flexDirection: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'row',
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <LinearGradient
                                                      endY={100}
                                                      {...GlobalStyles.LinearGradientStyles(
                                                        theme
                                                      )['Linear Gradient']
                                                        .props}
                                                      color1={
                                                        (checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.App[
                                                              'Gray Linear Light'
                                                            ]
                                                          : palettes.App[
                                                              'Light Linear - Light'
                                                            ]) ??
                                                        palettes.App[
                                                          'Gray Linear Light'
                                                        ]
                                                      }
                                                      color2={
                                                        (checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.App[
                                                              'Gray Linear Dark'
                                                            ]
                                                          : palettes.App[
                                                              'Light Linear - Dark'
                                                            ]) ??
                                                        palettes.App[
                                                          'Gray Linear Dark'
                                                        ]
                                                      }
                                                      endX={0}
                                                      startX={0}
                                                      startY={0}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Linear Gradient']
                                                            .style,
                                                          {
                                                            borderColor: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                palettes.Brand
                                                                  .Black,
                                                            },
                                                            borderLeftWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            flexDirection: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'row',
                                                            },
                                                            height: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            justifyContent: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'flex-end',
                                                            },
                                                            maxHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            maxWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                            minHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                            width: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {/* Categories Text */}
                                                      <Text
                                                        accessible={true}
                                                        selectable={false}
                                                        {...GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text White']
                                                          .props}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )[
                                                              'Chart Text White'
                                                            ].style,
                                                            {
                                                              color: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .White
                                                                    : palettes
                                                                        .Brand
                                                                        .Black,
                                                              },
                                                              paddingLeft: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 4,
                                                              },
                                                              paddingRight: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 4,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {categoriesListData?.default_value
                                                          ? categoriesListData
                                                              ?._expense_heads
                                                              ?.title
                                                          : categoriesListData?.title}
                                                      </Text>
                                                    </LinearGradient>
                                                    <SimpleStyleFlatList
                                                      data={[
                                                        1, 2, 3, 4, 5, 6, 7, 8,
                                                        9, 10, 11, 12,
                                                      ]}
                                                      decelerationRate={
                                                        'normal'
                                                      }
                                                      inverted={false}
                                                      keyExtractor={(
                                                        listData,
                                                        index
                                                      ) =>
                                                        listData?.id ??
                                                        listData?.uuid ??
                                                        index?.toString() ??
                                                        JSON.stringify(listData)
                                                      }
                                                      keyboardShouldPersistTaps={
                                                        'never'
                                                      }
                                                      listKey={JSON.stringify([
                                                        1, 2, 3, 4, 5, 6, 7, 8,
                                                        9, 10, 11, 12,
                                                      ])}
                                                      nestedScrollEnabled={
                                                        false
                                                      }
                                                      numColumns={1}
                                                      onEndReachedThreshold={
                                                        0.5
                                                      }
                                                      pagingEnabled={false}
                                                      renderItem={({
                                                        item,
                                                        index,
                                                      }) => {
                                                        const listData = item;
                                                        return (
                                                          <LinearGradient
                                                            endY={100}
                                                            startX={0}
                                                            startY={0}
                                                            color1={
                                                              (checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .Background
                                                                : palettes.App[
                                                                    'Light Linear - Dark'
                                                                  ]) ??
                                                              theme.colors
                                                                .branding
                                                                .primary
                                                            }
                                                            color2={
                                                              (checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.App[
                                                                    'Gray Linear Dark'
                                                                  ]
                                                                : palettes.App[
                                                                    'Light Linear - Light'
                                                                  ]) ??
                                                              theme.colors
                                                                .branding
                                                                .secondary
                                                            }
                                                            color3={
                                                              checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .Background
                                                                : palettes.App[
                                                                    'Light Linear - Dark'
                                                                  ]
                                                            }
                                                            endX={0}
                                                            style={StyleSheet.applyWidth(
                                                              {
                                                                alignItems: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    'center',
                                                                },
                                                                borderBottomWidth:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                borderColor: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    palettes
                                                                      .Brand
                                                                      .Black,
                                                                },
                                                                borderRightWidth:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                height: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                justifyContent:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'center',
                                                                  },
                                                                maxHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                minHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                minWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 75,
                                                                },
                                                                width: [
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 75,
                                                                  },
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.BigScreen,
                                                                    value:
                                                                      (dimensions.width -
                                                                        dimensions.width *
                                                                          (15 /
                                                                            100) -
                                                                        320) /
                                                                      14,
                                                                  },
                                                                ],
                                                              },
                                                              dimensions.width
                                                            )}
                                                          >
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )[
                                                                'Chart Text White'
                                                              ].props}
                                                              style={StyleSheet.applyWidth(
                                                                StyleSheet.compose(
                                                                  GlobalStyles.TextStyles(
                                                                    theme
                                                                  )[
                                                                    'Chart Text White'
                                                                  ].style,
                                                                  {
                                                                    color: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        Constants[
                                                                          'SWITCH_SCREEN_MODE'
                                                                        ]
                                                                          ? palettes
                                                                              .Brand
                                                                              .Black
                                                                          : palettes
                                                                              .Brand
                                                                              .White,
                                                                    },
                                                                  }
                                                                ),
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {'$ '}
                                                              {formatNumber(
                                                                getInitValue(
                                                                  numberInputsOperating,
                                                                  findIndexExpense(
                                                                    sortCategoriesExpense(
                                                                      allCategoriesOperating
                                                                    ),
                                                                    categoriesListData
                                                                  ),
                                                                  index
                                                                )
                                                              )}
                                                            </Text>
                                                          </LinearGradient>
                                                        );
                                                      }}
                                                      showsHorizontalScrollIndicator={
                                                        true
                                                      }
                                                      showsVerticalScrollIndicator={
                                                        true
                                                      }
                                                      snapToAlignment={'start'}
                                                      horizontal={true}
                                                      style={StyleSheet.applyWidth(
                                                        {
                                                          flex: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                        },
                                                        dimensions.width
                                                      )}
                                                    />
                                                  </View>
                                                </>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            style={StyleSheet.applyWidth(
                                              {
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          />
                                        </View>
                                        {/* Right */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              position: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'absolute',
                                              },
                                              right: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 0,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          <SimpleStyleFlatList
                                            data={totalOperatingPerCategory}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(listData, index) =>
                                              listData?.id ??
                                              listData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(listData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'FaEXBKli'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const listData = item;
                                              return (
                                                <>
                                                  {/* Total Gradiant */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Category Gradient']
                                                      .props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Category Gradient']
                                                          .style,
                                                        {
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value:
                                                              (dimensions.width -
                                                                dimensions.width *
                                                                  (15 / 100) -
                                                                320) /
                                                              14,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Total Value */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .White
                                                                  : palettes
                                                                      .Brand
                                                                      .Black,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {'$ '}
                                                      {formatNumber(listData)}
                                                    </Text>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                          />
                                          {/* List 2 */}
                                          <SimpleStyleFlatList
                                            data={calculateBenchmark(
                                              totalOperatingPerCategory
                                            )}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(list2Data, index) =>
                                              list2Data?.id ??
                                              list2Data?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(list2Data)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'9vSIz9gQ'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const list2Data = item;
                                              return (
                                                <>
                                                  {/* Benchmarks */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    color1={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Light'
                                                      ]
                                                    }
                                                    color2={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Dark'
                                                      ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        alignItems: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'center',
                                                        },
                                                        borderBottomWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        flex: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: null,
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        justifyContent: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'center',
                                                        },
                                                        maxHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 75,
                                                        },
                                                        width: [
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value:
                                                              (dimensions.width -
                                                                dimensions.width *
                                                                  (15 / 100) -
                                                                320) /
                                                              14,
                                                          },
                                                        ],
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Benchmarks */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .White
                                                                  : palettes
                                                                      .Brand
                                                                      .Black,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {formatPercentage(
                                                        list2Data
                                                      )}
                                                    </Text>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                          />
                                        </View>
                                      </View>
                                      {/* Bottom Total */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            borderColor: {
                                              minWidth: Breakpoints.Laptop,
                                              value: palettes.Brand.Black,
                                            },
                                            bottom: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 0,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '100%',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Total Operating Expenses */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flex: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          <LinearGradient
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            {...GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Blue Linear'].props}
                                            color1={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            color2={
                                              palettes.App['App Blue Light']
                                            }
                                            color3={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].style,
                                                {
                                                  borderBottomWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.White,
                                                  },
                                                  borderRightWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  justifyContent: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  maxWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                  minWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  {
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Total Operating Expenses'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Total Operating Expenses */}
                                          <SimpleStyleFlatList
                                            data={totalOperatingPerMonth.concat(
                                              calculatePercentIncome(
                                                totalIncomePerMonth.slice(
                                                  0,
                                                  12
                                                ),
                                                totalOperatingPerMonth.slice(
                                                  12,
                                                  undefined
                                                )
                                              )
                                            )}
                                            decelerationRate={'normal'}
                                            inverted={false}
                                            keyExtractor={(
                                              totalOperatingExpensesData,
                                              index
                                            ) =>
                                              totalOperatingExpensesData?.id ??
                                              totalOperatingExpensesData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(
                                                totalOperatingExpensesData
                                              )
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'huHOznS7'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const totalOperatingExpensesData =
                                                item;
                                              return (
                                                <>
                                                  {/* Total Operating Expenses */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].props}
                                                    color1={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    color2={
                                                      palettes.App[
                                                        'App Blue Light'
                                                      ]
                                                    }
                                                    color3={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].style,
                                                        {
                                                          borderBottomWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          borderRightWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value:
                                                              (dimensions.width -
                                                                dimensions.width *
                                                                  (15 / 100) -
                                                                320) /
                                                              14,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Total Operating Expenses */}
                                                    <>
                                                      {!(index < 13) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'$ '}
                                                          {formatNumber(
                                                            totalOperatingExpensesData
                                                          )}
                                                        </Text>
                                                      )}
                                                    </>
                                                    {/* %Income */}
                                                    <>
                                                      {!(
                                                        index === 13
                                                      ) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {formatPercentage(
                                                            totalOperatingExpensesData
                                                          )}
                                                        </Text>
                                                      )}
                                                    </>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            horizontal={true}
                                            scrollEnabled={false}
                                            showsHorizontalScrollIndicator={
                                              false
                                            }
                                          />
                                        </View>
                                      </View>
                                    </View>
                                    {/* Finance Expenses */}
                                    <View>
                                      {/* Header View */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            padding: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 6,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Header */}
                                        <Text
                                          accessible={true}
                                          selectable={false}
                                          {...GlobalStyles.TextStyles(theme)[
                                            'Header'
                                          ].props}
                                          style={StyleSheet.applyWidth(
                                            StyleSheet.compose(
                                              GlobalStyles.TextStyles(theme)[
                                                'Header'
                                              ].style,
                                              {
                                                color: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: checkScreenMode(
                                                    Variables
                                                  )
                                                    ? palettes.Brand.White
                                                    : palettes.Brand.Black,
                                                },
                                                fontSize: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 18,
                                                },
                                                textAlign: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'right',
                                                },
                                              }
                                            ),
                                            dimensions.width
                                          )}
                                        >
                                          {'Finance Expenses'}
                                        </Text>
                                      </View>
                                      {/* Categories */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            borderTopWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            flexDirection: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'row',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Left */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              backgroundColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: checkScreenMode(
                                                  Variables
                                                )
                                                  ? undefined
                                                  : palettes.Brand.White,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Categories List */}
                                          <SimpleStyleFlatList
                                            data={allCategoriesFinance}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(
                                              categoriesListData,
                                              index
                                            ) =>
                                              categoriesListData?.id ??
                                              categoriesListData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(categoriesListData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'Ce3p5tWs'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const categoriesListData = item;
                                              return (
                                                <>
                                                  {/* Categories */}
                                                  <View
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        flexDirection: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'row',
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <LinearGradient
                                                      endY={100}
                                                      {...GlobalStyles.LinearGradientStyles(
                                                        theme
                                                      )['Linear Gradient']
                                                        .props}
                                                      color1={
                                                        (checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.App[
                                                              'Gray Linear Light'
                                                            ]
                                                          : palettes.App[
                                                              'Light Linear - Light'
                                                            ]) ??
                                                        palettes.App[
                                                          'Gray Linear Light'
                                                        ]
                                                      }
                                                      color2={
                                                        (checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.App[
                                                              'Gray Linear Dark'
                                                            ]
                                                          : palettes.App[
                                                              'Light Linear - Dark'
                                                            ]) ??
                                                        palettes.App[
                                                          'Gray Linear Dark'
                                                        ]
                                                      }
                                                      endX={0}
                                                      startX={0}
                                                      startY={0}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Linear Gradient']
                                                            .style,
                                                          {
                                                            borderColor: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                palettes.Brand
                                                                  .Black,
                                                            },
                                                            borderLeftWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            flexDirection: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'row',
                                                            },
                                                            height: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            justifyContent: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'flex-end',
                                                            },
                                                            maxHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            maxWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                            minHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                            width: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {/* Categories Text */}
                                                      <Text
                                                        accessible={true}
                                                        selectable={false}
                                                        {...GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text White']
                                                          .props}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )[
                                                              'Chart Text White'
                                                            ].style,
                                                            {
                                                              color: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .White
                                                                    : palettes
                                                                        .Brand
                                                                        .Black,
                                                              },
                                                              paddingLeft: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 4,
                                                              },
                                                              paddingRight: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 4,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {categoriesListData?.default_value
                                                          ? categoriesListData
                                                              ?._expense_heads
                                                              ?.title
                                                          : categoriesListData?.title}
                                                      </Text>
                                                    </LinearGradient>
                                                    <SimpleStyleFlatList
                                                      data={[
                                                        1, 2, 3, 4, 5, 6, 7, 8,
                                                        9, 10, 11, 12,
                                                      ]}
                                                      decelerationRate={
                                                        'normal'
                                                      }
                                                      inverted={false}
                                                      keyExtractor={(
                                                        listData,
                                                        index
                                                      ) =>
                                                        listData?.id ??
                                                        listData?.uuid ??
                                                        index?.toString() ??
                                                        JSON.stringify(listData)
                                                      }
                                                      keyboardShouldPersistTaps={
                                                        'never'
                                                      }
                                                      listKey={JSON.stringify([
                                                        1, 2, 3, 4, 5, 6, 7, 8,
                                                        9, 10, 11, 12,
                                                      ])}
                                                      nestedScrollEnabled={
                                                        false
                                                      }
                                                      numColumns={1}
                                                      onEndReachedThreshold={
                                                        0.5
                                                      }
                                                      pagingEnabled={false}
                                                      renderItem={({
                                                        item,
                                                        index,
                                                      }) => {
                                                        const listData = item;
                                                        return (
                                                          <LinearGradient
                                                            endY={100}
                                                            startX={0}
                                                            startY={0}
                                                            color1={
                                                              (checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .Background
                                                                : palettes.App[
                                                                    'Light Linear - Dark'
                                                                  ]) ??
                                                              theme.colors
                                                                .branding
                                                                .primary
                                                            }
                                                            color2={
                                                              (checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.App[
                                                                    'Gray Linear Dark'
                                                                  ]
                                                                : palettes.App[
                                                                    'Light Linear - Light'
                                                                  ]) ??
                                                              theme.colors
                                                                .branding
                                                                .secondary
                                                            }
                                                            color3={
                                                              checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .Background
                                                                : palettes.App[
                                                                    'Light Linear - Dark'
                                                                  ]
                                                            }
                                                            endX={0}
                                                            style={StyleSheet.applyWidth(
                                                              {
                                                                alignItems: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    'center',
                                                                },
                                                                borderBottomWidth:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                borderColor: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    palettes
                                                                      .Brand
                                                                      .Black,
                                                                },
                                                                borderRightWidth:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                height: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                justifyContent:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'center',
                                                                  },
                                                                maxHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                minHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                minWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 75,
                                                                },
                                                                width: [
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 75,
                                                                  },
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.BigScreen,
                                                                    value:
                                                                      (dimensions.width -
                                                                        dimensions.width *
                                                                          (15 /
                                                                            100) -
                                                                        320) /
                                                                      14,
                                                                  },
                                                                ],
                                                              },
                                                              dimensions.width
                                                            )}
                                                          >
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )[
                                                                'Chart Text White'
                                                              ].props}
                                                              style={StyleSheet.applyWidth(
                                                                StyleSheet.compose(
                                                                  GlobalStyles.TextStyles(
                                                                    theme
                                                                  )[
                                                                    'Chart Text White'
                                                                  ].style,
                                                                  {
                                                                    color: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        Constants[
                                                                          'SWITCH_SCREEN_MODE'
                                                                        ]
                                                                          ? palettes
                                                                              .Brand
                                                                              .Black
                                                                          : palettes
                                                                              .Brand
                                                                              .White,
                                                                    },
                                                                  }
                                                                ),
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {'$ '}
                                                              {formatNumber(
                                                                getInitValue(
                                                                  numberInputsFinance,
                                                                  findIndexExpense(
                                                                    sortCategoriesExpense(
                                                                      allCategoriesFinance
                                                                    ),
                                                                    categoriesListData
                                                                  ),
                                                                  index
                                                                )
                                                              )}
                                                            </Text>
                                                          </LinearGradient>
                                                        );
                                                      }}
                                                      showsHorizontalScrollIndicator={
                                                        true
                                                      }
                                                      showsVerticalScrollIndicator={
                                                        true
                                                      }
                                                      snapToAlignment={'start'}
                                                      horizontal={true}
                                                      style={StyleSheet.applyWidth(
                                                        {
                                                          flex: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                        },
                                                        dimensions.width
                                                      )}
                                                    />
                                                  </View>
                                                </>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            style={StyleSheet.applyWidth(
                                              {
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          />
                                        </View>
                                        {/* Right */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              position: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'absolute',
                                              },
                                              right: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 0,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          <SimpleStyleFlatList
                                            data={totalFinancePerCategory}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(listData, index) =>
                                              listData?.id ??
                                              listData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(listData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'pkkPJTco'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const listData = item;
                                              return (
                                                <>
                                                  {/* Total Gradiant */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Category Gradient']
                                                      .props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Category Gradient']
                                                          .style,
                                                        {
                                                          flex: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: null,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: null,
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value:
                                                              (dimensions.width -
                                                                dimensions.width *
                                                                  (15 / 100) -
                                                                320) /
                                                              14,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Total Value */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .White
                                                                  : palettes
                                                                      .Brand
                                                                      .Black,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {'$ '}
                                                      {formatNumber(listData)}
                                                    </Text>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                          />
                                          {/* List 2 */}
                                          <SimpleStyleFlatList
                                            data={calculateBenchmark(
                                              totalFinancePerCategory
                                            )}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(list2Data, index) =>
                                              list2Data?.id ??
                                              list2Data?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(list2Data)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'OFW7zYan'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const list2Data = item;
                                              return (
                                                <>
                                                  {/* Benchmarks */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    color1={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Light'
                                                      ]
                                                    }
                                                    color2={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Dark'
                                                      ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        alignItems: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'center',
                                                        },
                                                        borderBottomWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        flex: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: null,
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        justifyContent: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'center',
                                                        },
                                                        maxHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 75,
                                                        },
                                                        width: [
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value:
                                                              (dimensions.width -
                                                                dimensions.width *
                                                                  (15 / 100) -
                                                                320) /
                                                              14,
                                                          },
                                                        ],
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Benchmarks */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .White
                                                                  : palettes
                                                                      .Brand
                                                                      .Black,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {formatPercentage(
                                                        list2Data
                                                      )}
                                                    </Text>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                          />
                                        </View>
                                      </View>
                                      {/* Bottom Total */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            bottom: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 0,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: '100%',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Total Finance Expenses */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flex: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          <LinearGradient
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            {...GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Blue Linear'].props}
                                            color1={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            color2={
                                              palettes.App['App Blue Light']
                                            }
                                            color3={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].style,
                                                {
                                                  borderBottomWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.White,
                                                  },
                                                  borderRightWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  justifyContent: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  maxWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                  minWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  {
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Total Finance Expenses'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Total Finance Expenses */}
                                          <SimpleStyleFlatList
                                            data={totalFinancePerMonth.concat([
                                              '',
                                            ])}
                                            decelerationRate={'normal'}
                                            inverted={false}
                                            keyExtractor={(
                                              totalFinanceExpensesData,
                                              index
                                            ) =>
                                              totalFinanceExpensesData?.id ??
                                              totalFinanceExpensesData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(
                                                totalFinanceExpensesData
                                              )
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'uiUmwyiN'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const totalFinanceExpensesData =
                                                item;
                                              return (
                                                <>
                                                  {/* Total Finance Expenses */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].props}
                                                    color1={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    color2={
                                                      palettes.App[
                                                        'App Blue Light'
                                                      ]
                                                    }
                                                    color3={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].style,
                                                        {
                                                          borderBottomWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          borderRightWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value:
                                                              (dimensions.width -
                                                                dimensions.width *
                                                                  (15 / 100) -
                                                                320) /
                                                              14,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Total Finance Expenses */}
                                                    <>
                                                      {!(index < 13) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'$ '}
                                                          {formatNumber(
                                                            totalFinanceExpensesData
                                                          )}
                                                        </Text>
                                                      )}
                                                    </>
                                                    {/* %Income */}
                                                    <>
                                                      {!(
                                                        index === 13
                                                      ) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {calculatePercentIncome(
                                                            totalIncomePerMonth.slice(
                                                              0,
                                                              12
                                                            ),
                                                            totalFinancePerMonth.slice(
                                                              12,
                                                              undefined
                                                            )
                                                          )}
                                                          {'%'}
                                                        </Text>
                                                      )}
                                                    </>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            horizontal={true}
                                            scrollEnabled={false}
                                            showsHorizontalScrollIndicator={
                                              false
                                            }
                                          />
                                        </View>
                                        {/* Total Cash Paid Out */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flex: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                              marginTop: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Linear Gradient 2 */}
                                          <LinearGradient
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            {...GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Blue Linear'].props}
                                            color1={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            color2={
                                              palettes.App['App Blue Light']
                                            }
                                            color3={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].style,
                                                {
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.White,
                                                  },
                                                  borderRightWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  justifyContent: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  maxWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                  minWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  {
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Total Cash Paid Out'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Total Cash Paid Out */}
                                          <SimpleStyleFlatList
                                            data={totalCashPaidOut.concat([''])}
                                            decelerationRate={'normal'}
                                            inverted={false}
                                            keyExtractor={(
                                              totalCashPaidOutData,
                                              index
                                            ) =>
                                              totalCashPaidOutData?.id ??
                                              totalCashPaidOutData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(
                                                totalCashPaidOutData
                                              )
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'RQr5dDi9'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const totalCashPaidOutData = item;
                                              return (
                                                <>
                                                  {/* Total Cash Paid Out */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].props}
                                                    color1={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    color2={
                                                      palettes.App[
                                                        'App Blue Light'
                                                      ]
                                                    }
                                                    color3={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          borderRightWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value:
                                                              (dimensions.width -
                                                                dimensions.width *
                                                                  (15 / 100) -
                                                                320) /
                                                              14,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Total Cash Paid Out */}
                                                    <>
                                                      {!(index < 13) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'$ '}
                                                          {formatNumber(
                                                            totalCashPaidOutData
                                                          )}
                                                        </Text>
                                                      )}
                                                    </>
                                                    {/* %Income */}
                                                    <>
                                                      {!(
                                                        index === 13
                                                      ) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {calculatePercentIncome(
                                                            totalIncomePerMonth.slice(
                                                              0,
                                                              12
                                                            ),
                                                            totalCashPaidOut.slice(
                                                              12,
                                                              undefined
                                                            )
                                                          )}
                                                          {'%'}
                                                        </Text>
                                                      )}
                                                    </>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            horizontal={true}
                                            scrollEnabled={false}
                                            showsHorizontalScrollIndicator={
                                              false
                                            }
                                          />
                                        </View>
                                        {/* Cash On Hand */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              borderColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: palettes.Brand.White,
                                              },
                                              flex: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 1,
                                              },
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              height: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 25,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Linear Gradient 2 */}
                                          <LinearGradient
                                            endY={100}
                                            startX={0}
                                            startY={0}
                                            {...GlobalStyles.LinearGradientStyles(
                                              theme
                                            )['Blue Linear'].props}
                                            color1={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            color2={
                                              palettes.App['App Blue Light']
                                            }
                                            color3={
                                              palettes.Brand['App Blue Dark']
                                            }
                                            endX={0}
                                            style={StyleSheet.applyWidth(
                                              StyleSheet.compose(
                                                GlobalStyles.LinearGradientStyles(
                                                  theme
                                                )['Blue Linear'].style,
                                                {
                                                  borderColor: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: palettes.Brand.White,
                                                  },
                                                  borderRightWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 1,
                                                  },
                                                  justifyContent: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 'flex-end',
                                                  },
                                                  maxWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                  minWidth: {
                                                    minWidth:
                                                      Breakpoints.Laptop,
                                                    value: 300,
                                                  },
                                                }
                                              ),
                                              dimensions.width
                                            )}
                                          >
                                            <Text
                                              accessible={true}
                                              selectable={false}
                                              {...GlobalStyles.TextStyles(
                                                theme
                                              )['Chart Text'].props}
                                              style={StyleSheet.applyWidth(
                                                StyleSheet.compose(
                                                  GlobalStyles.TextStyles(
                                                    theme
                                                  )['Chart Text'].style,
                                                  {
                                                    paddingRight: {
                                                      minWidth:
                                                        Breakpoints.Laptop,
                                                      value: 4,
                                                    },
                                                  }
                                                ),
                                                dimensions.width
                                              )}
                                            >
                                              {'Cash On Hand (end of month)'}
                                            </Text>
                                          </LinearGradient>
                                          {/* Cash On Hand */}
                                          <SimpleStyleFlatList
                                            data={Constants[
                                              'TOTAL_CASH_ON_HAND'
                                            ]
                                              .concat([
                                                (totalIncomePerMonth &&
                                                  totalIncomePerMonth[12]) -
                                                  (totalCashPaidOut &&
                                                    totalCashPaidOut[12]),
                                              ])
                                              .concat([['']])}
                                            decelerationRate={'normal'}
                                            inverted={false}
                                            keyExtractor={(
                                              cashOnHandData,
                                              index
                                            ) =>
                                              cashOnHandData?.id ??
                                              cashOnHandData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(cashOnHandData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'O4p8J972'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const cashOnHandData = item;
                                              return (
                                                <>
                                                  {/* Cash On Hand */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Blue Linear'].props}
                                                    color1={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    color2={
                                                      palettes.App[
                                                        'App Blue Light'
                                                      ]
                                                    }
                                                    color3={
                                                      palettes.Brand[
                                                        'App Blue Dark'
                                                      ]
                                                    }
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Blue Linear'].style,
                                                        {
                                                          borderColor: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value:
                                                              palettes.Brand
                                                                .White,
                                                          },
                                                          borderRightWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                          minWidth: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value:
                                                              (dimensions.width -
                                                                dimensions.width *
                                                                  (15 / 100) -
                                                                320) /
                                                              14,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Cash On Hand */}
                                                    <>
                                                      {!(index < 13) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {'$ '}
                                                          {formatNumber(
                                                            cashOnHandData
                                                          )}
                                                        </Text>
                                                      )}
                                                    </>
                                                    {/* %Income */}
                                                    <>
                                                      {!(
                                                        index === 13
                                                      ) ? null : (
                                                        <Text
                                                          accessible={true}
                                                          selectable={false}
                                                          {...GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text'].props}
                                                          style={StyleSheet.applyWidth(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )['Chart Text']
                                                              .style,
                                                            dimensions.width
                                                          )}
                                                        >
                                                          {toFixed2(
                                                            (((totalIncomePerMonth &&
                                                              totalIncomePerMonth[12]) -
                                                              (totalCashPaidOut &&
                                                                totalCashPaidOut[12])) *
                                                              100) /
                                                              (totalIncomePerMonth &&
                                                                totalIncomePerMonth[12])
                                                          )}
                                                          {'%'}
                                                        </Text>
                                                      )}
                                                    </>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            horizontal={true}
                                            scrollEnabled={false}
                                            showsHorizontalScrollIndicator={
                                              false
                                            }
                                          />
                                        </View>
                                      </View>
                                    </View>
                                    {/* Other Operating Data */}
                                    <View>
                                      {/* Header View */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            padding: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 6,
                                            },
                                            width: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 300,
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Header */}
                                        <Text
                                          accessible={true}
                                          selectable={false}
                                          {...GlobalStyles.TextStyles(theme)[
                                            'Header'
                                          ].props}
                                          style={StyleSheet.applyWidth(
                                            StyleSheet.compose(
                                              GlobalStyles.TextStyles(theme)[
                                                'Header'
                                              ].style,
                                              {
                                                color: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: checkScreenMode(
                                                    Variables
                                                  )
                                                    ? palettes.Brand.White
                                                    : palettes.Brand.Black,
                                                },
                                                fontSize: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 18,
                                                },
                                                textAlign: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 'right',
                                                },
                                              }
                                            ),
                                            dimensions.width
                                          )}
                                        >
                                          {'Other Operating Data'}
                                        </Text>
                                      </View>
                                      {/* Categories */}
                                      <View
                                        style={StyleSheet.applyWidth(
                                          {
                                            borderTopWidth: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 1,
                                            },
                                            flexDirection: {
                                              minWidth: Breakpoints.Laptop,
                                              value: 'row',
                                            },
                                          },
                                          dimensions.width
                                        )}
                                      >
                                        {/* Left */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              backgroundColor: {
                                                minWidth: Breakpoints.Laptop,
                                                value: checkScreenMode(
                                                  Variables
                                                )
                                                  ? undefined
                                                  : palettes.Brand.White,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          {/* Categories List */}
                                          <SimpleStyleFlatList
                                            data={allCategoriesOther}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(
                                              categoriesListData,
                                              index
                                            ) =>
                                              categoriesListData?.id ??
                                              categoriesListData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(categoriesListData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'MQ82wYmp'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const categoriesListData = item;
                                              return (
                                                <>
                                                  {/* Categories */}
                                                  <View
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        flexDirection: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'row',
                                                        },
                                                        width: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: '100%',
                                                        },
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    <LinearGradient
                                                      endY={100}
                                                      {...GlobalStyles.LinearGradientStyles(
                                                        theme
                                                      )['Linear Gradient']
                                                        .props}
                                                      color1={
                                                        (checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.App[
                                                              'Gray Linear Light'
                                                            ]
                                                          : palettes.App[
                                                              'Light Linear - Light'
                                                            ]) ??
                                                        palettes.App[
                                                          'Gray Linear Light'
                                                        ]
                                                      }
                                                      color2={
                                                        (checkScreenMode(
                                                          Variables
                                                        )
                                                          ? palettes.App[
                                                              'Gray Linear Dark'
                                                            ]
                                                          : palettes.App[
                                                              'Light Linear - Dark'
                                                            ]) ??
                                                        palettes.App[
                                                          'Gray Linear Dark'
                                                        ]
                                                      }
                                                      endX={0}
                                                      startX={0}
                                                      startY={0}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.LinearGradientStyles(
                                                            theme
                                                          )['Linear Gradient']
                                                            .style,
                                                          {
                                                            borderColor: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                palettes.Brand
                                                                  .Black,
                                                            },
                                                            borderLeftWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 1,
                                                            },
                                                            flexDirection: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'row',
                                                            },
                                                            height: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            justifyContent: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 'flex-end',
                                                            },
                                                            maxHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            maxWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                            minHeight: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 25,
                                                            },
                                                            minWidth: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                            width: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value: 300,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {/* Categories Text */}
                                                      <Text
                                                        accessible={true}
                                                        selectable={false}
                                                        {...GlobalStyles.TextStyles(
                                                          theme
                                                        )['Chart Text White']
                                                          .props}
                                                        style={StyleSheet.applyWidth(
                                                          StyleSheet.compose(
                                                            GlobalStyles.TextStyles(
                                                              theme
                                                            )[
                                                              'Chart Text White'
                                                            ].style,
                                                            {
                                                              color: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value:
                                                                  checkScreenMode(
                                                                    Variables
                                                                  )
                                                                    ? palettes
                                                                        .Brand
                                                                        .White
                                                                    : palettes
                                                                        .Brand
                                                                        .Black,
                                                              },
                                                              paddingLeft: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 4,
                                                              },
                                                              paddingRight: {
                                                                minWidth:
                                                                  Breakpoints.Laptop,
                                                                value: 4,
                                                              },
                                                            }
                                                          ),
                                                          dimensions.width
                                                        )}
                                                      >
                                                        {categoriesListData?.default_value
                                                          ? categoriesListData
                                                              ?._expense_heads
                                                              ?.title
                                                          : categoriesListData?.title}
                                                      </Text>
                                                    </LinearGradient>
                                                    <SimpleStyleFlatList
                                                      data={[
                                                        1, 2, 3, 4, 5, 6, 7, 8,
                                                        9, 10, 11, 12,
                                                      ]}
                                                      decelerationRate={
                                                        'normal'
                                                      }
                                                      inverted={false}
                                                      keyExtractor={(
                                                        listData,
                                                        index
                                                      ) =>
                                                        listData?.id ??
                                                        listData?.uuid ??
                                                        index?.toString() ??
                                                        JSON.stringify(listData)
                                                      }
                                                      keyboardShouldPersistTaps={
                                                        'never'
                                                      }
                                                      listKey={JSON.stringify([
                                                        1, 2, 3, 4, 5, 6, 7, 8,
                                                        9, 10, 11, 12,
                                                      ])}
                                                      nestedScrollEnabled={
                                                        false
                                                      }
                                                      numColumns={1}
                                                      onEndReachedThreshold={
                                                        0.5
                                                      }
                                                      pagingEnabled={false}
                                                      renderItem={({
                                                        item,
                                                        index,
                                                      }) => {
                                                        const listData = item;
                                                        return (
                                                          <LinearGradient
                                                            endY={100}
                                                            startX={0}
                                                            startY={0}
                                                            color1={
                                                              (checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .Background
                                                                : palettes.App[
                                                                    'Light Linear - Dark'
                                                                  ]) ??
                                                              theme.colors
                                                                .branding
                                                                .primary
                                                            }
                                                            color2={
                                                              (checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.App[
                                                                    'Gray Linear Dark'
                                                                  ]
                                                                : palettes.App[
                                                                    'Light Linear - Light'
                                                                  ]) ??
                                                              theme.colors
                                                                .branding
                                                                .secondary
                                                            }
                                                            color3={
                                                              checkScreenMode(
                                                                Variables
                                                              )
                                                                ? palettes.Brand
                                                                    .Background
                                                                : palettes.App[
                                                                    'Light Linear - Dark'
                                                                  ]
                                                            }
                                                            endX={0}
                                                            style={StyleSheet.applyWidth(
                                                              {
                                                                alignItems: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    'center',
                                                                },
                                                                borderBottomWidth:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                borderColor: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value:
                                                                    palettes
                                                                      .Brand
                                                                      .Black,
                                                                },
                                                                borderRightWidth:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 1,
                                                                  },
                                                                height: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                justifyContent:
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value:
                                                                      'center',
                                                                  },
                                                                maxHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                minHeight: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 25,
                                                                },
                                                                minWidth: {
                                                                  minWidth:
                                                                    Breakpoints.Laptop,
                                                                  value: 75,
                                                                },
                                                                width: [
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.Laptop,
                                                                    value: 75,
                                                                  },
                                                                  {
                                                                    minWidth:
                                                                      Breakpoints.BigScreen,
                                                                    value:
                                                                      (dimensions.width -
                                                                        dimensions.width *
                                                                          (15 /
                                                                            100) -
                                                                        320) /
                                                                      14,
                                                                  },
                                                                ],
                                                              },
                                                              dimensions.width
                                                            )}
                                                          >
                                                            <Text
                                                              accessible={true}
                                                              selectable={false}
                                                              {...GlobalStyles.TextStyles(
                                                                theme
                                                              )[
                                                                'Chart Text White'
                                                              ].props}
                                                              style={StyleSheet.applyWidth(
                                                                StyleSheet.compose(
                                                                  GlobalStyles.TextStyles(
                                                                    theme
                                                                  )[
                                                                    'Chart Text White'
                                                                  ].style,
                                                                  {
                                                                    color: {
                                                                      minWidth:
                                                                        Breakpoints.Laptop,
                                                                      value:
                                                                        Constants[
                                                                          'SWITCH_SCREEN_MODE'
                                                                        ]
                                                                          ? palettes
                                                                              .Brand
                                                                              .Black
                                                                          : palettes
                                                                              .Brand
                                                                              .White,
                                                                    },
                                                                  }
                                                                ),
                                                                dimensions.width
                                                              )}
                                                            >
                                                              {'$ '}
                                                              {formatNumber(
                                                                getInitValue(
                                                                  numberInputsOther,
                                                                  findIndexExpense(
                                                                    sortCategoriesExpense(
                                                                      allCategoriesOther
                                                                    ),
                                                                    categoriesListData
                                                                  ),
                                                                  index
                                                                )
                                                              )}
                                                            </Text>
                                                          </LinearGradient>
                                                        );
                                                      }}
                                                      showsHorizontalScrollIndicator={
                                                        true
                                                      }
                                                      showsVerticalScrollIndicator={
                                                        true
                                                      }
                                                      snapToAlignment={'start'}
                                                      horizontal={true}
                                                      style={StyleSheet.applyWidth(
                                                        {
                                                          flex: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 1,
                                                          },
                                                        },
                                                        dimensions.width
                                                      )}
                                                    />
                                                  </View>
                                                </>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                            style={StyleSheet.applyWidth(
                                              {
                                                flex: {
                                                  minWidth: Breakpoints.Laptop,
                                                  value: 1,
                                                },
                                              },
                                              dimensions.width
                                            )}
                                          />
                                        </View>
                                        {/* Right */}
                                        <View
                                          style={StyleSheet.applyWidth(
                                            {
                                              flexDirection: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'row',
                                              },
                                              position: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 'absolute',
                                              },
                                              right: {
                                                minWidth: Breakpoints.Laptop,
                                                value: 0,
                                              },
                                            },
                                            dimensions.width
                                          )}
                                        >
                                          <SimpleStyleFlatList
                                            data={totalOtherPerCategory}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(listData, index) =>
                                              listData?.id ??
                                              listData?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(listData)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'s6n1LhCg'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const listData = item;
                                              return (
                                                <>
                                                  {/* Total Gradiant */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    {...GlobalStyles.LinearGradientStyles(
                                                      theme
                                                    )['Category Gradient']
                                                      .props}
                                                    color1={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]
                                                    }
                                                    color2={
                                                      checkScreenMode(Variables)
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      StyleSheet.compose(
                                                        GlobalStyles.LinearGradientStyles(
                                                          theme
                                                        )['Category Gradient']
                                                          .style,
                                                        {
                                                          flex: {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: null,
                                                          },
                                                          maxWidth: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value: null,
                                                          },
                                                          width: {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value:
                                                              (dimensions.width -
                                                                dimensions.width *
                                                                  (15 / 100) -
                                                                320) /
                                                              14,
                                                          },
                                                        }
                                                      ),
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Total Value */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .White
                                                                  : palettes
                                                                      .Brand
                                                                      .Black,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {'$ '}
                                                      {formatNumber(listData)}
                                                    </Text>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                          />
                                          {/* List 2 */}
                                          <SimpleStyleFlatList
                                            data={calculateBenchmark(
                                              totalOtherPerCategory
                                            )}
                                            decelerationRate={'normal'}
                                            horizontal={false}
                                            inverted={false}
                                            keyExtractor={(list2Data, index) =>
                                              list2Data?.id ??
                                              list2Data?.uuid ??
                                              index?.toString() ??
                                              JSON.stringify(list2Data)
                                            }
                                            keyboardShouldPersistTaps={'never'}
                                            listKey={'CoYK3Zfi'}
                                            nestedScrollEnabled={false}
                                            numColumns={1}
                                            onEndReachedThreshold={0.5}
                                            pagingEnabled={false}
                                            renderItem={({ item, index }) => {
                                              const list2Data = item;
                                              return (
                                                <>
                                                  {/* Benchmarks */}
                                                  <LinearGradient
                                                    endY={100}
                                                    startX={0}
                                                    startY={0}
                                                    color1={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Light'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Light'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Light'
                                                      ]
                                                    }
                                                    color2={
                                                      (checkScreenMode(
                                                        Variables
                                                      )
                                                        ? palettes.App[
                                                            'Gray Linear Dark'
                                                          ]
                                                        : palettes.App[
                                                            'Light Linear - Dark'
                                                          ]) ??
                                                      palettes.App[
                                                        'Gray Linear Dark'
                                                      ]
                                                    }
                                                    color3={null}
                                                    endX={0}
                                                    style={StyleSheet.applyWidth(
                                                      {
                                                        alignItems: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'center',
                                                        },
                                                        borderBottomWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 1,
                                                        },
                                                        flex: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: null,
                                                        },
                                                        height: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        justifyContent: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 'center',
                                                        },
                                                        maxHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minHeight: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 25,
                                                        },
                                                        minWidth: {
                                                          minWidth:
                                                            Breakpoints.Laptop,
                                                          value: 75,
                                                        },
                                                        width: [
                                                          {
                                                            minWidth:
                                                              Breakpoints.Laptop,
                                                            value: 75,
                                                          },
                                                          {
                                                            minWidth:
                                                              Breakpoints.BigScreen,
                                                            value:
                                                              (dimensions.width -
                                                                dimensions.width *
                                                                  (15 / 100) -
                                                                320) /
                                                              14,
                                                          },
                                                        ],
                                                      },
                                                      dimensions.width
                                                    )}
                                                  >
                                                    {/* Benchmarks */}
                                                    <Text
                                                      accessible={true}
                                                      selectable={false}
                                                      {...GlobalStyles.TextStyles(
                                                        theme
                                                      )['Chart Text White']
                                                        .props}
                                                      style={StyleSheet.applyWidth(
                                                        StyleSheet.compose(
                                                          GlobalStyles.TextStyles(
                                                            theme
                                                          )['Chart Text White']
                                                            .style,
                                                          {
                                                            color: {
                                                              minWidth:
                                                                Breakpoints.Laptop,
                                                              value:
                                                                checkScreenMode(
                                                                  Variables
                                                                )
                                                                  ? palettes
                                                                      .Brand
                                                                      .White
                                                                  : palettes
                                                                      .Brand
                                                                      .Black,
                                                            },
                                                          }
                                                        ),
                                                        dimensions.width
                                                      )}
                                                    >
                                                      {formatPercentage(
                                                        list2Data
                                                      )}
                                                    </Text>
                                                  </LinearGradient>
                                                </>
                                              );
                                            }}
                                            showsHorizontalScrollIndicator={
                                              true
                                            }
                                            showsVerticalScrollIndicator={true}
                                            snapToAlignment={'start'}
                                          />
                                        </View>
                                      </View>
                                    </View>
                                  </View>
                                </View>
                              </View>
                            </View>
                          </SimpleStyleScrollView>
                        </SimpleStyleScrollView>
                      )}
                    </>
                  );
                }}
              </DefaultApi.FetchGetExpenseHeadsGET>
            </View>

            <Modal
              animationType={'none'}
              supportedOrientations={['portrait', 'landscape']}
              transparent={true}
              visible={visibleWhatIf}
            >
              <BlurView
                {...GlobalStyles.BlurViewStyles(theme)['Blur View'].props}
                intensity={15}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.BlurViewStyles(theme)['Blur View'].style,
                    {
                      flex: { minWidth: Breakpoints.Laptop, value: 1 },
                      marginLeft: [
                        { minWidth: Breakpoints.Laptop, value: '20%' },
                        { minWidth: Breakpoints.Desktop, value: '15%' },
                      ],
                    }
                  ),
                  dimensions.width
                )}
                tint={'dark'}
              >
                <ScenarioBlock
                  setVisibleWhatIf={visibleWhatIf =>
                    setVisibleWhatIf(visibleWhatIf)
                  }
                  visibleWhatIf={visibleWhatIf}
                />
              </BlurView>
            </Modal>
          </View>
        )}
      </>
      <>
        {!!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <ScreenSizeWarningBlock />
        )}
      </>
    </ScreenContainer>
  );
};

export default withTheme(OverviewScreen);
